export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type AggregateData = {
  __typename?: 'AggregateData';
  count: Scalars['Int']['output'];
  lowerQuartile: Scalars['Float']['output'];
  max: Scalars['Float']['output'];
  median: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  upperQuartile: Scalars['Float']['output'];
};

export type AllInstitutionsFilters = {
  clusters?: InputMaybe<Array<Scalars['String']['input']>>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overallRank?: InputMaybe<RankFilter>;
  subjects?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AllRankedInstitutions = {
  __typename?: 'AllRankedInstitutions';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  institutions: Array<AllRankedInstitutionsData>;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AllRankedInstitutionsData = {
  __typename?: 'AllRankedInstitutionsData';
  continent: Continent;
  country: Scalars['String']['output'];
  founded?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  institutionData?: Maybe<AllRankedInstitutionsDataInstitutions>;
  institutionId: Scalars['String']['output'];
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  results?: Maybe<Array<AllRankedInstitutionsDataResult>>;
};

export type AllRankedInstitutionsDataInstitutions = {
  __typename?: 'AllRankedInstitutionsDataInstitutions';
  cluster?: Maybe<Cluster>;
  totalStaff: Scalars['Int']['output'];
  totalStudents: Scalars['Int']['output'];
};

export type AllRankedInstitutionsDataResult = {
  __typename?: 'AllRankedInstitutionsDataResult';
  jointRanked: Scalars['Boolean']['output'];
  level1: AllRankedInstitutionsResultLevel1;
  rank: GraBanding;
  year: Scalars['Int']['output'];
};

export type AllRankedInstitutionsResultLevel1 = {
  __typename?: 'AllRankedInstitutionsResultLevel1';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AllWurInstitutions = {
  __typename?: 'AllWURInstitutions';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  institutions: Array<WurInstitution>;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AvailableYears = {
  __typename?: 'AvailableYears';
  id: Scalars['ID']['output'];
  releaseDate: Scalars['String']['output'];
  resource: Scalars['ID']['output'];
  year: Scalars['Int']['output'];
};

export type BestRank = {
  __typename?: 'BestRank';
  institution: Institution;
  rank?: Maybe<GraBanding>;
};

export type BibliometricResult = {
  __typename?: 'BibliometricResult';
  citation: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  institution: Institution;
  internationalCollaboration?: Maybe<Scalars['Float']['output']>;
  researchProductivity?: Maybe<Scalars['Float']['output']>;
  resource: Scalars['ID']['output'];
};

export type BibliometricSubject = {
  __typename?: 'BibliometricSubject';
  aggregateData: AggregateData;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  resource?: Maybe<Scalars['ID']['output']>;
  results: Array<BibliometricResult>;
  shortName: Scalars['String']['output'];
  timeframe?: Maybe<GraQuarter>;
};


export type BibliometricSubjectAggregateDataArgs = {
  filter?: InputMaybe<GraAggregateFilterInput>;
};

/**
 * A pre-defined group of institutions that are selected internally at THE.
 *
 * e.g. "Old Stars", "Technology Challengers"
 */
export type Cluster = {
  __typename?: 'Cluster';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  institutions: Array<WurInstitution>;
  name: Scalars['String']['output'];
  resource: Scalars['ID']['output'];
  /** List of subject areas that this group of institutions are strongest in. */
  strengthsText: Scalars['String']['output'];
  /** List of subject areas that this group of institutions are weakest in. */
  weaknessesText: Scalars['String']['output'];
};

export enum Continent {
  Africa = 'AFRICA',
  Antartica = 'ANTARTICA',
  Asia = 'ASIA',
  Europe = 'EUROPE',
  NorthAmerica = 'NORTH_AMERICA',
  Oceania = 'OCEANIA',
  SouthAmerica = 'SOUTH_AMERICA'
}

export type DataPointsPeerChangeDraft = {
  __typename?: 'DataPointsPeerChangeDraft';
  fullName?: Maybe<Scalars['String']['output']>;
  institutionIds: Array<Scalars['String']['output']>;
  peers?: Maybe<Array<DataPointsProductInstitution>>;
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type DataPointsProduct = {
  __typename?: 'DataPointsProduct';
  institutionGroup: Array<Maybe<DataPointsProductInstitution>>;
  institutionGroups: Array<DataPointsProductInstitutionGroup>;
  institutionId: Scalars['String']['output'];
  locations: DataPointsProductLocations;
  name: Scalars['String']['output'];
  peersInfo: DataPointsProductPeersInfo;
};


export type DataPointsProductInstitutionGroupArgs = {
  name: Scalars['String']['input'];
};

export type DataPointsProductInstitution = {
  __typename?: 'DataPointsProductInstitution';
  continent: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  institutionId: Scalars['String']['output'];
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DataPointsProductInstitutionGroup = {
  __typename?: 'DataPointsProductInstitutionGroup';
  institutions: Array<DataPointsProductInstitution>;
  name: Scalars['String']['output'];
};

export type DataPointsProductLocations = {
  __typename?: 'DataPointsProductLocations';
  continents: Array<Scalars['String']['output']>;
  countries: Array<Scalars['String']['output']>;
};

export type DataPointsProductPeersInfo = {
  __typename?: 'DataPointsProductPeersInfo';
  lastPeerChangeDate?: Maybe<Scalars['Date']['output']>;
  maxPeerCount: Scalars['Int']['output'];
  peerChangeDraft?: Maybe<DataPointsPeerChangeDraft>;
  peerChangeIntervalWeeks: Scalars['Int']['output'];
  peerChangeOpen: Scalars['Boolean']['output'];
  supportsChangingPeers: Scalars['Boolean']['output'];
  supportsPeers: Scalars['Boolean']['output'];
};

export type DetailedSubject = {
  __typename?: 'DetailedSubject';
  aggregateData: AggregateData;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  level3s: Array<GraLevel3>;
  metrics: Array<DetailedSubjectMetric>;
  name: Scalars['String']['output'];
  resource: Scalars['ID']['output'];
  results: Array<Result>;
  shortName: Scalars['String']['output'];
};


export type DetailedSubjectResultsArgs = {
  input?: InputMaybe<GraAggregateFilterInput>;
};

export type DetailedSubjectMetric = {
  __typename?: 'DetailedSubjectMetric';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ExploreInstitution = {
  __typename?: 'ExploreInstitution';
  allowScoresForExcluded: Scalars['Boolean']['output'];
  country: Scalars['String']['output'];
  currencyCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type ExploreInstitutionInput = {
  allowScoresForExcluded: Scalars['Boolean']['input'];
  country: Scalars['String']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type GraAggregateFilterInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  institutionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type GraBanding = {
  __typename?: 'GRABanding';
  higher: Scalars['Float']['output'];
  lower: Scalars['Float']['output'];
};

export type GraCluster = {
  __typename?: 'GRACluster';
  bestRanked: Array<Maybe<BestRank>>;
  description?: Maybe<Scalars['String']['output']>;
  geographies: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  institutionCount?: Maybe<Scalars['Int']['output']>;
  medianAge?: Maybe<Scalars['Int']['output']>;
  medianRank?: Maybe<GraBanding>;
  name: Scalars['String']['output'];
  strengthsText?: Maybe<Scalars['String']['output']>;
  weaknessesText?: Maybe<Scalars['String']['output']>;
};

export type GraDataPointsProductLocations = {
  __typename?: 'GRADataPointsProductLocations';
  continents: Array<Scalars['String']['output']>;
  countries: Array<Scalars['String']['output']>;
};

export type GraInstitutionData = {
  __typename?: 'GRAInstitutionData';
  cluster: GraCluster;
  countryRank?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  femaleStudentPercentage: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  institution: Institution;
  institutionsInCountryCount: Scalars['Int']['output'];
  internationalStudentPercentage: Scalars['Float']['output'];
  level1sData: Array<SubjectData>;
  pppToUsd: Scalars['Float']['output'];
  resource: Scalars['ID']['output'];
  studentToStaffPercentage: Scalars['Float']['output'];
  totalStudents: Scalars['Int']['output'];
};

export type GraLevel1 = {
  __typename?: 'GRALevel1';
  aggregateData: AggregateData;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  level2s: Array<GraLevel2>;
  name: Scalars['String']['output'];
  resource: Scalars['ID']['output'];
  result?: Maybe<Level1Result>;
  results: Array<Level1Result>;
};


export type GraLevel1AggregateDataArgs = {
  filter?: InputMaybe<GraAggregateFilterInput>;
};


export type GraLevel1ResultArgs = {
  institutionId?: InputMaybe<Scalars['String']['input']>;
};


export type GraLevel1ResultsArgs = {
  input?: InputMaybe<GraAggregateFilterInput>;
};

export type GraLevel2 = {
  __typename?: 'GRALevel2';
  aggregateData: AggregateData;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  level3s: Array<GraLevel3>;
  name: Scalars['String']['output'];
  resource: Scalars['ID']['output'];
  result: Level2Result;
  results: Array<Level2Result>;
};


export type GraLevel2AggregateDataArgs = {
  filter?: InputMaybe<GraAggregateFilterInput>;
};


export type GraLevel2ResultArgs = {
  institutionId?: InputMaybe<Scalars['String']['input']>;
};


export type GraLevel2ResultsArgs = {
  input?: InputMaybe<GraAggregateFilterInput>;
};

export type GraLevel3 = {
  __typename?: 'GRALevel3';
  aggregateData: AggregateData;
  aggregateScoreData: AggregateData;
  aggregateScorePerformanceData: AggregateData;
  aggregateValueData: AggregateData;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  resource: Scalars['ID']['output'];
  result: Result;
  results: Array<Result>;
  valueType: ValueType;
  weighting: Scalars['Float']['output'];
};


export type GraLevel3AggregateDataArgs = {
  aggregateType?: InputMaybe<GraMetricAggregateType>;
  filter?: InputMaybe<GraAggregateFilterInput>;
  populationYear?: InputMaybe<Scalars['Int']['input']>;
};


export type GraLevel3ResultArgs = {
  institutionId?: InputMaybe<Scalars['String']['input']>;
};


export type GraLevel3ResultsArgs = {
  filter?: InputMaybe<GraAggregateFilterInput>;
};

export enum GraMetricAggregateType {
  Score = 'SCORE',
  Value = 'VALUE'
}

export enum GraQuarter {
  Q1 = 'Q1',
  Q2 = 'Q2',
  Q3 = 'Q3',
  Q4 = 'Q4',
  Year = 'YEAR'
}

/**
 * TODO: Should be moved to GRA repository
 * Represents a yearly GRA data release for the selected release.
 */
export type GraRelease = {
  __typename?: 'GRARelease';
  bandings: Array<GraBanding>;
  bibliometricSubject: BibliometricSubject;
  bibliometricSubjects?: Maybe<Array<BibliometricSubject>>;
  clusters: Array<GraCluster>;
  detailedSubject: DetailedSubject;
  detailedSubjects: Array<DetailedSubject>;
  embargoEndDate: Scalars['String']['output'];
  embargoStartDate: Scalars['String']['output'];
  freeEmbargoStartDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  institutionData?: Maybe<GraInstitutionData>;
  institutionsData?: Maybe<InstitutionsData>;
  level1: GraLevel1;
  level1s: Array<GraLevel1>;
  levelDefinitions?: Maybe<GraReleaseLevelDefinitions>;
  locations: GraDataPointsProductLocations;
  releaseDate: Scalars['String']['output'];
  resource: Scalars['ID']['output'];
  totalRankedInstitutions: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  wurDetailsEmbargoStartDate: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};


/**
 * TODO: Should be moved to GRA repository
 * Represents a yearly GRA data release for the selected release.
 */
export type GraReleaseBibliometricSubjectArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  quarter?: InputMaybe<GraQuarter>;
};


/**
 * TODO: Should be moved to GRA repository
 * Represents a yearly GRA data release for the selected release.
 */
export type GraReleaseBibliometricSubjectsArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  quarters?: InputMaybe<Array<GraQuarter>>;
};


/**
 * TODO: Should be moved to GRA repository
 * Represents a yearly GRA data release for the selected release.
 */
export type GraReleaseDetailedSubjectArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


/**
 * TODO: Should be moved to GRA repository
 * Represents a yearly GRA data release for the selected release.
 */
export type GraReleaseDetailedSubjectsArgs = {
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * TODO: Should be moved to GRA repository
 * Represents a yearly GRA data release for the selected release.
 */
export type GraReleaseInstitutionDataArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/**
 * TODO: Should be moved to GRA repository
 * Represents a yearly GRA data release for the selected release.
 */
export type GraReleaseInstitutionsDataArgs = {
  filter?: InputMaybe<GraAggregateFilterInput>;
};


/**
 * TODO: Should be moved to GRA repository
 * Represents a yearly GRA data release for the selected release.
 */
export type GraReleaseLevel1Args = {
  name?: InputMaybe<Scalars['String']['input']>;
};


/**
 * TODO: Should be moved to GRA repository
 * Represents a yearly GRA data release for the selected release.
 */
export type GraReleaseLevel1sArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GraReleaseDate = {
  __typename?: 'GRAReleaseDate';
  datasetType: Scalars['String']['output'];
  embargoedUntilDate: Scalars['String']['output'];
  freeEmbargoedDate: Scalars['String']['output'];
  releaseDate: Scalars['String']['output'];
  wurDetailsEmbargoedDate?: Maybe<Scalars['String']['output']>;
  year: Scalars['Int']['output'];
};

export type GraReleaseLevelDefinitions = {
  __typename?: 'GRAReleaseLevelDefinitions';
  level1?: Maybe<Array<Maybe<GraReleaseLevelItemDefinition>>>;
  level2?: Maybe<Array<Maybe<GraReleaseLevelItemDefinition>>>;
  level3?: Maybe<Array<Maybe<GraReleaseLevelItemDefinition>>>;
};

export type GraReleaseLevelItemDefinition = {
  __typename?: 'GRAReleaseLevelItemDefinition';
  levelId?: Maybe<Scalars['String']['output']>;
  longName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  rankingYear?: Maybe<Scalars['Int']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  weighting?: Maybe<Scalars['Float']['output']>;
};

export type Institution = {
  __typename?: 'Institution';
  country: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  institutionId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  resource: Scalars['ID']['output'];
};

export type InstitutionData = {
  __typename?: 'InstitutionData';
  iid?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type InstitutionFilterInput = {
  iids?: InputMaybe<Array<Scalars['String']['input']>>;
  location?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * A user-defined group of institutions
 *
 * e.g. "Old Stars", "Technology Challengers"
 */
export type InstitutionGroup = {
  __typename?: 'InstitutionGroup';
  id: Scalars['ID']['output'];
  institutions: Array<WurInstitution>;
  name: Scalars['String']['output'];
  resource: Scalars['ID']['output'];
};

export type InstitutionsData = {
  __typename?: 'InstitutionsData';
  count: Scalars['Int']['output'];
  data: Array<GraInstitutionData>;
};

export type Level1 = {
  __typename?: 'Level1';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  level2: Array<Maybe<Level2>>;
  rankingRows: Array<Maybe<RankingRow>>;
};


export type Level1Level2Args = {
  iids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type Level1RankingRowsArgs = {
  filter?: InputMaybe<InstitutionFilterInput>;
};

export type Level1Result = {
  __typename?: 'Level1Result';
  decile?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  institution: Institution;
  isImputed?: Maybe<Scalars['Boolean']['output']>;
  jointRanked: Scalars['Boolean']['output'];
  rank: GraBanding;
  resource: Scalars['ID']['output'];
  score: GraBanding;
  scoreNumber: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};

export type Level2 = {
  __typename?: 'Level2';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  level3: Array<Maybe<Level3>>;
  rankingRows: Array<Maybe<RankingRow>>;
};


export type Level2Level3Args = {
  iids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Level2Result = {
  __typename?: 'Level2Result';
  decile?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  institution: Institution;
  isImputed?: Maybe<Scalars['Boolean']['output']>;
  jointRanked: Scalars['Boolean']['output'];
  rank: Scalars['Float']['output'];
  resource: Scalars['ID']['output'];
  score: Scalars['Float']['output'];
  scoreNumber: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};

export type Level3 = {
  __typename?: 'Level3';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  rankingRows: Array<Maybe<RankingRow>>;
};

/** The ranking methodology to be used by The ranking API */
export enum Methodology {
  Wur = 'WUR',
  Wur20 = 'WUR20'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptEmbargo: Array<ResourcePermission>;
  /** Adds a new Scenario for given scenario data. */
  addScenario: ScenarioMutationResult;
  /** Marks active scenarios as archived (with timestamp) for a given scenario Ids. */
  archiveScenarios: ScenarioMutationResult;
  /** Edits an existing scenario for a given scenario Id and the payload. */
  editScenario: Scenario;
  setActiveInstitution?: Maybe<UserInstitution>;
  setProductPeers: Array<DataPointsProductInstitution>;
  setProductPeersDraft?: Maybe<DataPointsPeerChangeDraft>;
  /** Marks archived scenarios as active (with timestamp) for a given scenario Ids. */
  unarchiveScenarios: ScenarioMutationResult;
  wurReporterInterimAddScenario: ScenarioMutationResult;
  wurReporterInterimArchiveScenarios: ScenarioMutationResult;
  wurReporterInterimEditScenario: Scenario;
  wurReporterInterimUnarchiveScenarios: ScenarioMutationResult;
};


export type MutationAcceptEmbargoArgs = {
  dataset: Scalars['String']['input'];
  institutionId: Scalars['String']['input'];
  productName: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};


export type MutationAddScenarioArgs = {
  input: ScenarioDataInput;
};


export type MutationArchiveScenariosArgs = {
  institutionId: Scalars['String']['input'];
  scenarioIds: Array<Scalars['String']['input']>;
};


export type MutationEditScenarioArgs = {
  input: ScenarioDataInput;
  scenarioId: Scalars['String']['input'];
};


export type MutationSetActiveInstitutionArgs = {
  id: Scalars['String']['input'];
};


export type MutationSetProductPeersArgs = {
  institutionId: Scalars['String']['input'];
  peerIds: Array<Scalars['String']['input']>;
  productName: Scalars['String']['input'];
};


export type MutationSetProductPeersDraftArgs = {
  institutionId: Scalars['String']['input'];
  peerIds: Array<Scalars['String']['input']>;
  productName: Scalars['String']['input'];
};


export type MutationUnarchiveScenariosArgs = {
  institutionId: Scalars['String']['input'];
  scenarioIds: Array<Scalars['String']['input']>;
};


export type MutationWurReporterInterimAddScenarioArgs = {
  input: ScenarioDataInput;
};


export type MutationWurReporterInterimArchiveScenariosArgs = {
  allowScoresForExcluded: Scalars['Boolean']['input'];
  institutionId: Scalars['String']['input'];
  scenarioIds: Array<Scalars['String']['input']>;
};


export type MutationWurReporterInterimEditScenarioArgs = {
  input: ScenarioDataInput;
  scenarioId: Scalars['String']['input'];
};


export type MutationWurReporterInterimUnarchiveScenariosArgs = {
  allowScoresForExcluded: Scalars['Boolean']['input'];
  institutionId: Scalars['String']['input'];
  scenarioIds: Array<Scalars['String']['input']>;
};

export type PermissionAction = {
  __typename?: 'PermissionAction';
  action: Scalars['String']['output'];
  grant: Scalars['Boolean']['output'];
};

/**
 * Used to represent which segment of a given year the data update is relevant
 * to.
 */
export enum Quarter {
  Q1 = 'Q1',
  Q2 = 'Q2',
  Q3 = 'Q3',
  Q4 = 'Q4',
  Year = 'YEAR'
}

export type Query = {
  __typename?: 'Query';
  allInstitutions?: Maybe<AllWurInstitutions>;
  allRankedInstitutions: AllRankedInstitutions;
  /** Return all available WUR release years. */
  availableYears: Array<AvailableYears>;
  /**
   * Returns the 'Citation' pillar for the given years (and quarters where
   * available).
   *
   * @TODO: Revisit, return type may not be optimal.
   * @TODO: Revisit, figure out permissions for citations
   */
  citations: Array<WurPillar>;
  getProductPeersDraft?: Maybe<DataPointsPeerChangeDraft>;
  institution?: Maybe<WurInstitution>;
  institutionGroups?: Maybe<InstitutionGroup>;
  legacyPermissions: Array<ResourcePermission>;
  /**
   * Returns the active institution for the user defined by the authentication
   * token. If the token defines multiple institutions, this can be overridden by
   * providing the institution ID in the 'x-datapoints-institution' request header.
   */
  myInstitutions: UserInstitutions;
  /**
   * TODO: Should be moved to GRA repository
   * Return NEW generic ranking data for current release.
   */
  newrelease?: Maybe<GraRelease>;
  /**
   * TODO: Should be moved to GRA repository
   * Return NEW generic ranking data for all available releases
   * or only those matching a specified list of years.
   */
  newreleases?: Maybe<Array<Maybe<GraRelease>>>;
  permissions: Array<ResourcePermission>;
  /** Return generic ranking data for current release. */
  release: GraRelease;
  /** Return specific release dates based on release names and years. */
  releaseDates?: Maybe<Array<GraReleaseDate>>;
  releases: Array<GraRelease>;
  scenario?: Maybe<Scenario>;
  /** Return available scenarios for a given institution id and scenario Ids. */
  scenarios?: Maybe<Array<Scenario>>;
  /** Return available submissions for a given institution id and year. */
  submission?: Maybe<Submission>;
  /** Return the WUR Release for a given year. */
  wurRelease?: Maybe<WurRelease>;
  wurReleaseMetric?: Maybe<WurReleaseMetric>;
  /**
   * Return all available WUR Releases or only those matching the specified list of
   * years.
   */
  wurReleases: Array<WurRelease>;
  wurReporterInterimScenario?: Maybe<Scenario>;
  wurReporterInterimScenarios?: Maybe<Array<Scenario>>;
};


export type QueryAllInstitutionsArgs = {
  excludeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filters?: InputMaybe<AllInstitutionsFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  rankYear: Scalars['Int']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QueryAllRankedInstitutionsArgs = {
  clusters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  institutionName?: InputMaybe<Scalars['String']['input']>;
  level1s?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<Scalars['String']['input']>;
  lowerOverallRank?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  releaseName: Scalars['String']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  upperOverallRank?: InputMaybe<Scalars['Float']['input']>;
  year: Scalars['Int']['input'];
};


export type QueryCitationsArgs = {
  years?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryGetProductPeersDraftArgs = {
  institutionId: Scalars['String']['input'];
  productName: Scalars['String']['input'];
};


export type QueryInstitutionArgs = {
  institutionId: Scalars['String']['input'];
};


export type QueryInstitutionGroupsArgs = {
  institutionIds: Array<Scalars['String']['input']>;
};


export type QueryLegacyPermissionsArgs = {
  institutionId: Scalars['String']['input'];
};


export type QueryMyInstitutionsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNewreleaseArgs = {
  year: Scalars['Int']['input'];
};


export type QueryNewreleasesArgs = {
  years?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryPermissionsArgs = {
  institutionId: Scalars['String']['input'];
};


export type QueryReleaseArgs = {
  detailedSubjectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  detailedSubjectMetricIds?: InputMaybe<Array<Scalars['String']['input']>>;
  institutionId?: InputMaybe<Scalars['String']['input']>;
  institutionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  level1Id?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  releaseName: Scalars['String']['input'];
  responseFields?: InputMaybe<Array<InputMaybe<ResponseFieldsListItem>>>;
  year: Scalars['Int']['input'];
};


export type QueryReleaseDatesArgs = {
  releaseNames: Array<InputMaybe<Scalars['String']['input']>>;
  years?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryReleasesArgs = {
  bibliometricSubjectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  bibliometricSubjectQuarters?: InputMaybe<Array<Scalars['String']['input']>>;
  detailedSubjectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  detailedSubjectMetricIds?: InputMaybe<Array<Scalars['String']['input']>>;
  institutionId?: InputMaybe<Scalars['String']['input']>;
  institutionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  level1Id?: InputMaybe<Scalars['String']['input']>;
  peerInstitutionId?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  releaseNames: Array<InputMaybe<Scalars['String']['input']>>;
  responseFields?: InputMaybe<Array<InputMaybe<ResponseFields2ListItem>>>;
  years?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryScenarioArgs = {
  allowScoresForExcluded: Scalars['Boolean']['input'];
  institutionId: Scalars['String']['input'];
  scenarioId: Scalars['String']['input'];
};


export type QueryScenariosArgs = {
  allowScoresForExcluded: Scalars['Boolean']['input'];
  filter?: InputMaybe<ScenarioInput>;
  institutionId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QuerySubmissionArgs = {
  institutionId: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};


export type QueryWurReleaseArgs = {
  year: Scalars['Int']['input'];
};


export type QueryWurReleaseMetricArgs = {
  year: Scalars['Int']['input'];
};


export type QueryWurReleasesArgs = {
  years?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryWurReporterInterimScenarioArgs = {
  allowScoresForExcluded: Scalars['Boolean']['input'];
  institutionId: Scalars['String']['input'];
  scenarioId: Scalars['String']['input'];
};


export type QueryWurReporterInterimScenariosArgs = {
  allowScoresForExcluded: Scalars['Boolean']['input'];
  filter?: InputMaybe<ScenarioInput>;
  institutionId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type RankFilter = {
  lower?: InputMaybe<Scalars['Int']['input']>;
  upper?: InputMaybe<Scalars['Int']['input']>;
};

export type RankingRow = {
  __typename?: 'RankingRow';
  displayRank: Scalars['String']['output'];
  displayScore: Scalars['String']['output'];
  id: Scalars['String']['output'];
  iid: Scalars['String']['output'];
  institutionData?: Maybe<InstitutionData>;
  isImputed?: Maybe<Scalars['Boolean']['output']>;
  scoreOrder?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type RankingRowInstitutionDataArgs = {
  filter?: InputMaybe<InstitutionFilterInput>;
};

/** Represents a yearly data release for the selected release. */
export type Release = {
  __typename?: 'Release';
  embargoEndDate: Scalars['String']['output'];
  embargoStartDate: Scalars['String']['output'];
  freeEmbargoStartDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  institutionData?: Maybe<Array<Maybe<InstitutionData>>>;
  level1: Array<Maybe<Level1>>;
  type: Scalars['String']['output'];
  wurDetailsEmbargoStartDate: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};


/** Represents a yearly data release for the selected release. */
export type ReleaseInstitutionDataArgs = {
  filter?: InputMaybe<InstitutionFilterInput>;
};


/** Represents a yearly data release for the selected release. */
export type ReleaseLevel1Args = {
  code: Scalars['String']['input'];
};

export type ResourcePermission = {
  __typename?: 'ResourcePermission';
  actions: Array<PermissionAction>;
  resource: Scalars['String']['output'];
};

export enum ResponseFields2ListItem {
  Bandings = 'BANDINGS',
  Bibliometricsubjects = 'BIBLIOMETRICSUBJECTS',
  Clusters = 'CLUSTERS',
  Detailedsubjects = 'DETAILEDSUBJECTS',
  Detailedsubjectslevel3S = 'DETAILEDSUBJECTSLEVEL3S',
  Institutiondata = 'INSTITUTIONDATA',
  Institutionsdata = 'INSTITUTIONSDATA',
  Level1S = 'LEVEL1S',
  Level2S = 'LEVEL2S',
  Level3S = 'LEVEL3S',
  Locations = 'LOCATIONS'
}

export enum ResponseFieldsListItem {
  Bandings = 'BANDINGS',
  Bibliometricsubjects = 'BIBLIOMETRICSUBJECTS',
  Clusters = 'CLUSTERS',
  Detailedsubjects = 'DETAILEDSUBJECTS',
  Detailedsubjectslevel3S = 'DETAILEDSUBJECTSLEVEL3S',
  Institutiondata = 'INSTITUTIONDATA',
  Institutionsdata = 'INSTITUTIONSDATA',
  Level1S = 'LEVEL1S',
  Level2S = 'LEVEL2S',
  Level3S = 'LEVEL3S',
  Locations = 'LOCATIONS'
}

export type Result = {
  __typename?: 'Result';
  decile?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  institution: Institution;
  isImputed?: Maybe<Scalars['Boolean']['output']>;
  jointRanked: Scalars['Boolean']['output'];
  pppValue?: Maybe<Scalars['Float']['output']>;
  rank: GraBanding;
  reportedValue?: Maybe<Scalars['Float']['output']>;
  resource: Scalars['ID']['output'];
  score: Scalars['Float']['output'];
  scoreNumber: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};

export type Scenario = {
  __typename?: 'Scenario';
  alexanderJson: ScenarioResult;
  archived?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  institution: ExploreInstitution;
  methodology: Scalars['String']['output'];
  name: Scalars['String']['output'];
  publicationYear?: Maybe<Scalars['Int']['output']>;
  resource: Scalars['ID']['output'];
  scenarioId: Scalars['String']['output'];
  scenarioInputs: ScenarioData;
  submissionYear?: Maybe<Scalars['Int']['output']>;
  totalScenariosCount: Scalars['Float']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ScenarioData = {
  __typename?: 'ScenarioData';
  artsAndHumanities?: Maybe<SubjectsFields>;
  businessAndEconomics?: Maybe<SubjectsFields>;
  clinicalAndHealth?: Maybe<SubjectsFields>;
  computerScience?: Maybe<SubjectsFields>;
  education?: Maybe<SubjectsFields>;
  engineering?: Maybe<SubjectsFields>;
  law?: Maybe<SubjectsFields>;
  lifeSciences?: Maybe<SubjectsFields>;
  overall?: Maybe<SubjectsFields>;
  physicalSciences?: Maybe<SubjectsFields>;
  psychology?: Maybe<SubjectsFields>;
  socialSciences?: Maybe<SubjectsFields>;
};

export type ScenarioDataInput = {
  artsAndHumanities?: InputMaybe<SubjectsFieldsInput>;
  businessAndEconomics?: InputMaybe<SubjectsFieldsInput>;
  clinicalAndHealth?: InputMaybe<SubjectsFieldsInput>;
  computerScience?: InputMaybe<SubjectsFieldsInput>;
  education?: InputMaybe<SubjectsFieldsInput>;
  engineering?: InputMaybe<SubjectsFieldsInput>;
  institution: ExploreInstitutionInput;
  law?: InputMaybe<SubjectsFieldsInput>;
  lifeSciences?: InputMaybe<SubjectsFieldsInput>;
  methodology: Scalars['String']['input'];
  name: Scalars['String']['input'];
  overall?: InputMaybe<SubjectsFieldsInput>;
  physicalSciences?: InputMaybe<SubjectsFieldsInput>;
  psychology?: InputMaybe<SubjectsFieldsInput>;
  socialSciences?: InputMaybe<SubjectsFieldsInput>;
};

export type ScenarioInput = {
  scenarioIds: Array<Scalars['String']['input']>;
};

export type ScenarioMutationResult = {
  __typename?: 'ScenarioMutationResult';
  id: Scalars['ID']['output'];
  resource: Scalars['ID']['output'];
  scenarioId: Scalars['String']['output'];
};

export type ScenarioResult = {
  __typename?: 'ScenarioResult';
  artsAndHumanities?: Maybe<ScenarioResultFields>;
  businessAndEconomics?: Maybe<ScenarioResultFields>;
  clinicalAndHealth?: Maybe<ScenarioResultFields>;
  computerScience?: Maybe<ScenarioResultFields>;
  education?: Maybe<ScenarioResultFields>;
  engineering?: Maybe<ScenarioResultFields>;
  law?: Maybe<ScenarioResultFields>;
  lifeSciences?: Maybe<ScenarioResultFields>;
  overall?: Maybe<ScenarioResultFields>;
  physicalSciences?: Maybe<ScenarioResultFields>;
  psychology?: Maybe<ScenarioResultFields>;
  socialSciences?: Maybe<ScenarioResultFields>;
};

/** The produced result via a methodology */
export type ScenarioResultFields = {
  __typename?: 'ScenarioResultFields';
  applicable: Scalars['Boolean']['output'];
  c1?: Maybe<Scalars['Float']['output']>;
  c2?: Maybe<Scalars['Float']['output']>;
  c3?: Maybe<Scalars['Float']['output']>;
  c4?: Maybe<Scalars['Float']['output']>;
  e1?: Maybe<Scalars['Float']['output']>;
  e2?: Maybe<Scalars['Float']['output']>;
  exclusions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  i1?: Maybe<Scalars['Float']['output']>;
  i2?: Maybe<Scalars['Float']['output']>;
  i3?: Maybe<Scalars['Float']['output']>;
  i4?: Maybe<Scalars['Float']['output']>;
  r1?: Maybe<Scalars['Float']['output']>;
  r2?: Maybe<Scalars['Float']['output']>;
  r3?: Maybe<Scalars['Float']['output']>;
  rankDisplay?: Maybe<Scalars['String']['output']>;
  rankNumber?: Maybe<Scalars['String']['output']>;
  scoreDisplay?: Maybe<Scalars['String']['output']>;
  scoreNumber?: Maybe<Scalars['String']['output']>;
  t1?: Maybe<Scalars['Float']['output']>;
  t2?: Maybe<Scalars['Float']['output']>;
  t3?: Maybe<Scalars['Float']['output']>;
  t4?: Maybe<Scalars['Float']['output']>;
  t5?: Maybe<Scalars['Float']['output']>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SubjectData = {
  __typename?: 'SubjectData';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  numberOfBachelorsStudents: Scalars['Float']['output'];
  numberOfDoctoratesStudents: Scalars['Float']['output'];
  numberOfInternationalStaff: Scalars['Float']['output'];
  numberOfInternationalStudents: Scalars['Float']['output'];
  numberOfMastersStudents: Scalars['Float']['output'];
  resource?: Maybe<Scalars['ID']['output']>;
  totalAcademicStaff: Scalars['Float']['output'];
  totalStudents: Scalars['Float']['output'];
};

export enum SubjectKeys {
  ArtsAndHumanities = 'artsAndHumanities',
  BusinessAndEconomics = 'businessAndEconomics',
  ClinicalAndHealth = 'clinicalAndHealth',
  ComputerScience = 'computerScience',
  Education = 'education',
  Engineering = 'engineering',
  Law = 'law',
  LifeSciences = 'lifeSciences',
  Overall = 'overall',
  PhysicalSciences = 'physicalSciences',
  Psychology = 'psychology',
  SocialSciences = 'socialSciences'
}

export type SubjectsFields = {
  __typename?: 'SubjectsFields';
  applicable?: Maybe<Scalars['Boolean']['output']>;
  citationScoreCnNormalised?: Maybe<Scalars['Float']['output']>;
  citationScoreNormalised?: Maybe<Scalars['Float']['output']>;
  influenceOfPublications?: Maybe<Scalars['Float']['output']>;
  internationalPublications?: Maybe<Scalars['Float']['output']>;
  numberOfAcademicStaff?: Maybe<Scalars['Float']['output']>;
  numberOfAcademicStaffOfInternationalOrOverseasOrigin?: Maybe<Scalars['Float']['output']>;
  numberOfDoctoratesAwarded?: Maybe<Scalars['Float']['output']>;
  numberOfPatentsCitingResearch?: Maybe<Scalars['Float']['output']>;
  numberOfProfessionalDoctoratesAwarded?: Maybe<Scalars['Float']['output']>;
  numberOfPublicationsInTheTop10Percentile?: Maybe<Scalars['Float']['output']>;
  numberOfResearchDoctoratesAwarded?: Maybe<Scalars['Float']['output']>;
  numberOfResearchStaff?: Maybe<Scalars['Float']['output']>;
  numberOfUndergraduateDegreesAwarded?: Maybe<Scalars['Float']['output']>;
  percentileFieldWeightedCitationImpact?: Maybe<Scalars['Float']['output']>;
  researchIncome?: Maybe<Scalars['Float']['output']>;
  researchIncomeFromIndustryAndCommerce?: Maybe<Scalars['Float']['output']>;
  researchVotes?: Maybe<Scalars['Float']['output']>;
  teachingVotes?: Maybe<Scalars['Float']['output']>;
  totalInstitutionalIncome?: Maybe<Scalars['Float']['output']>;
  totalNumberOfOutboundExchangeStudents?: Maybe<Scalars['Float']['output']>;
  totalNumberOfStudents?: Maybe<Scalars['Float']['output']>;
  totalNumberOfStudentsOfInternationalOrOverseasOrigin?: Maybe<Scalars['Float']['output']>;
  totalPublications?: Maybe<Scalars['Float']['output']>;
};

export type SubjectsFieldsInput = {
  applicable?: InputMaybe<Scalars['Boolean']['input']>;
  citationScoreCnNormalised?: InputMaybe<Scalars['Float']['input']>;
  citationScoreNormalised?: InputMaybe<Scalars['Float']['input']>;
  influenceOfPublications?: InputMaybe<Scalars['Float']['input']>;
  internationalPublications?: InputMaybe<Scalars['Float']['input']>;
  numberOfAcademicStaff?: InputMaybe<Scalars['Float']['input']>;
  numberOfAcademicStaffOfInternationalOrOverseasOrigin?: InputMaybe<Scalars['Float']['input']>;
  numberOfDoctoratesAwarded?: InputMaybe<Scalars['Float']['input']>;
  numberOfPatentsCitingResearch?: InputMaybe<Scalars['Float']['input']>;
  numberOfProfessionalDoctoratesAwarded?: InputMaybe<Scalars['Float']['input']>;
  numberOfPublicationsInTheTop10Percentile?: InputMaybe<Scalars['Float']['input']>;
  numberOfResearchDoctoratesAwarded?: InputMaybe<Scalars['Float']['input']>;
  numberOfResearchStaff?: InputMaybe<Scalars['Float']['input']>;
  numberOfUndergraduateDegreesAwarded?: InputMaybe<Scalars['Float']['input']>;
  percentileFieldWeightedCitationImpact?: InputMaybe<Scalars['Float']['input']>;
  researchIncome?: InputMaybe<Scalars['Float']['input']>;
  researchIncomeFromIndustryAndCommerce?: InputMaybe<Scalars['Float']['input']>;
  researchVotes?: InputMaybe<Scalars['Float']['input']>;
  teachingVotes?: InputMaybe<Scalars['Float']['input']>;
  totalInstitutionalIncome?: InputMaybe<Scalars['Float']['input']>;
  totalNumberOfOutboundExchangeStudents?: InputMaybe<Scalars['Float']['input']>;
  totalNumberOfStudents?: InputMaybe<Scalars['Float']['input']>;
  totalNumberOfStudentsOfInternationalOrOverseasOrigin?: InputMaybe<Scalars['Float']['input']>;
  totalPublications?: InputMaybe<Scalars['Float']['input']>;
};

export type Submission = {
  __typename?: 'Submission';
  artsAndHumanities?: Maybe<SubmissionsSubjectField>;
  businessAndEconomics?: Maybe<SubmissionsSubjectField>;
  clinicalAndHealth?: Maybe<SubmissionsSubjectField>;
  computerScience?: Maybe<SubmissionsSubjectField>;
  education?: Maybe<SubmissionsSubjectField>;
  engineering?: Maybe<SubmissionsSubjectField>;
  id: Scalars['ID']['output'];
  institutionId: Scalars['String']['output'];
  law?: Maybe<SubmissionsSubjectField>;
  lifeSciences?: Maybe<SubmissionsSubjectField>;
  overall?: Maybe<SubmissionsSubjectField>;
  physicalSciences?: Maybe<SubmissionsSubjectField>;
  psychology?: Maybe<SubmissionsSubjectField>;
  resource: Scalars['ID']['output'];
  socialSciences?: Maybe<SubmissionsSubjectField>;
  year: Scalars['Int']['output'];
};

export type SubmissionsSubjectField = {
  __typename?: 'SubmissionsSubjectField';
  applicable?: Maybe<Scalars['Boolean']['output']>;
  citationScoreCnNormalised?: Maybe<Scalars['Float']['output']>;
  citationScoreNormalised?: Maybe<Scalars['Float']['output']>;
  influenceOfPublications?: Maybe<Scalars['Float']['output']>;
  internationalPublications?: Maybe<Scalars['Float']['output']>;
  numberOfAcademicStaff?: Maybe<Scalars['Float']['output']>;
  numberOfAcademicStaffOfInternationalOrOverseasOrigin?: Maybe<Scalars['Float']['output']>;
  numberOfDoctoratesAwarded?: Maybe<Scalars['Float']['output']>;
  numberOfPatentsCitingResearch?: Maybe<Scalars['Float']['output']>;
  numberOfProfessionalDoctoratesAwarded?: Maybe<Scalars['Float']['output']>;
  numberOfPublicationsInTheTop10Percentile?: Maybe<Scalars['Float']['output']>;
  numberOfResearchDoctoratesAwarded?: Maybe<Scalars['Float']['output']>;
  numberOfResearchStaff?: Maybe<Scalars['Float']['output']>;
  numberOfUndergraduateDegreesAwarded?: Maybe<Scalars['Float']['output']>;
  percentileFieldWeightedCitationImpact?: Maybe<Scalars['Float']['output']>;
  researchIncome?: Maybe<Scalars['Float']['output']>;
  researchIncomeFromIndustryAndCommerce?: Maybe<Scalars['Float']['output']>;
  researchVotes?: Maybe<Scalars['Float']['output']>;
  teachingVotes?: Maybe<Scalars['Float']['output']>;
  totalInstitutionalIncome?: Maybe<Scalars['Float']['output']>;
  totalNumberOfOutboundExchangeStudents?: Maybe<Scalars['Float']['output']>;
  totalNumberOfStudents?: Maybe<Scalars['Float']['output']>;
  totalNumberOfStudentsOfInternationalOrOverseasOrigin?: Maybe<Scalars['Float']['output']>;
  totalPublications?: Maybe<Scalars['Float']['output']>;
};

export type UserInstitution = {
  __typename?: 'UserInstitution';
  continent: Scalars['String']['output'];
  country: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insightsPreviewUrl?: Maybe<Scalars['String']['output']>;
  institutionId: Scalars['String']['output'];
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  products: Array<DataPointsProduct>;
  resource: Scalars['ID']['output'];
};

export type UserInstitutions = {
  __typename?: 'UserInstitutions';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  institutions: Array<UserInstitution>;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

/**
 * TODO: Should be moved to GRA repository
 * GRA Types
 */
export enum ValueType {
  Currency = 'CURRENCY',
  Elsevier = 'ELSEVIER',
  Na = 'NA',
  Percentage = 'PERCENTAGE',
  Portal = 'PORTAL',
  Reputation = 'REPUTATION',
  Untyped = 'UNTYPED'
}

export type WurAggregateData = {
  __typename?: 'WURAggregateData';
  count: Scalars['Int']['output'];
  lowerQuartile: Scalars['Float']['output'];
  max: Scalars['Float']['output'];
  median: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  upperQuartile: Scalars['Float']['output'];
};

export type WurAggregateFilterInput = {
  /**
   * The name of a pre-defined cluster or a user-defined institution group.
   *
   * e.g. "Russell Group", "Ivy League Schools", "My Amazing Institutions"
   */
  group?: InputMaybe<Scalars['String']['input']>;
  institutionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Can be either a country or a continent. */
  region?: InputMaybe<Scalars['String']['input']>;
};

export type WurBanding = {
  __typename?: 'WURBanding';
  higher: Scalars['Float']['output'];
  lower: Scalars['Float']['output'];
};

export type WurBibliometricResult = {
  __typename?: 'WURBibliometricResult';
  citation: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  institution: WurInstitution;
  internationalCollaboration?: Maybe<Scalars['Float']['output']>;
  researchProductivity?: Maybe<Scalars['Float']['output']>;
  resource: Scalars['ID']['output'];
};

export type WurBibliometricSubject = {
  __typename?: 'WURBibliometricSubject';
  aggregateData?: Maybe<WurAggregateData>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  resource: Scalars['ID']['output'];
  result?: Maybe<WurBibliometricResult>;
  results: Array<WurBibliometricResult>;
  shortName: Scalars['String']['output'];
  timeframe: Quarter;
};


export type WurBibliometricSubjectAggregateDataArgs = {
  filter?: InputMaybe<WurAggregateFilterInput>;
};


export type WurBibliometricSubjectResultArgs = {
  institutionId: Scalars['String']['input'];
};


export type WurBibliometricSubjectResultsArgs = {
  input?: InputMaybe<WurAggregateFilterInput>;
};

export type WurDetailedSubject = {
  __typename?: 'WURDetailedSubject';
  aggregateData?: Maybe<WurAggregateData>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  metric?: Maybe<WurDetailedSubjectMetric>;
  metrics: Array<WurDetailedSubjectMetric>;
  name: Scalars['String']['output'];
  resource: Scalars['ID']['output'];
  result?: Maybe<WurDetailedSubjectResult>;
  results: Array<WurDetailedSubjectResult>;
  shortName: Scalars['String']['output'];
};


export type WurDetailedSubjectAggregateDataArgs = {
  filter?: InputMaybe<WurAggregateFilterInput>;
};


export type WurDetailedSubjectMetricArgs = {
  name: Scalars['String']['input'];
};


export type WurDetailedSubjectMetricsArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type WurDetailedSubjectResultArgs = {
  institutionId: Scalars['String']['input'];
};


export type WurDetailedSubjectResultsArgs = {
  input: WurAggregateFilterInput;
};

export type WurDetailedSubjectMetric = {
  __typename?: 'WURDetailedSubjectMetric';
  aggregateData?: Maybe<WurAggregateData>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  resource: Scalars['ID']['output'];
  result?: Maybe<WurDetailedSubjectMetricResult>;
  results: Array<WurDetailedSubjectMetricResult>;
  valueType: WurValueType;
};


export type WurDetailedSubjectMetricAggregateDataArgs = {
  filter?: InputMaybe<WurAggregateFilterInput>;
};


export type WurDetailedSubjectMetricResultArgs = {
  institutionId: Scalars['String']['input'];
};


export type WurDetailedSubjectMetricResultsArgs = {
  input?: InputMaybe<WurAggregateFilterInput>;
};

export type WurDetailedSubjectMetricResult = {
  __typename?: 'WURDetailedSubjectMetricResult';
  id: Scalars['ID']['output'];
  institution: WurInstitution;
  resource: Scalars['ID']['output'];
  score: Scalars['Float']['output'];
};

export type WurDetailedSubjectResult = {
  __typename?: 'WURDetailedSubjectResult';
  id: Scalars['ID']['output'];
  institution: WurInstitution;
  resource: Scalars['ID']['output'];
  score: Scalars['Float']['output'];
};

export type WurInstitution = {
  __typename?: 'WURInstitution';
  continent: Continent;
  country: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  founded?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  institutionId: Scalars['String']['output'];
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  resource: Scalars['ID']['output'];
  results?: Maybe<Array<WurSubjectResult>>;
  wurData?: Maybe<WurInstitutionData>;
};


export type WurInstitutionResultsArgs = {
  subjectNames?: InputMaybe<Array<Scalars['String']['input']>>;
  years: Array<Scalars['Int']['input']>;
};


export type WurInstitutionWurDataArgs = {
  year: Scalars['Int']['input'];
};

/**
 * World University Ranking data related to a specific institution for a specific
 * year.
 */
export type WurInstitutionData = {
  __typename?: 'WURInstitutionData';
  cluster?: Maybe<Cluster>;
  countryRank?: Maybe<Scalars['String']['output']>;
  /** The currency that is provided during data submission. */
  currency: Scalars['String']['output'];
  femaleStudentPercentage?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  institution: WurInstitution;
  institutionsInCountryCount: Scalars['Int']['output'];
  internationalStudentPercentage?: Maybe<Scalars['Float']['output']>;
  /** Purchasing power parity against the US Dollar. */
  pppToUsd: Scalars['Float']['output'];
  resource: Scalars['ID']['output'];
  studentToStaffPercentage?: Maybe<Scalars['Float']['output']>;
  subjectData?: Maybe<WurSubjectData>;
  subjectsData: Array<WurSubjectData>;
  totalStaff?: Maybe<Scalars['Int']['output']>;
  totalStudents?: Maybe<Scalars['Int']['output']>;
};


/**
 * World University Ranking data related to a specific institution for a specific
 * year.
 */
export type WurInstitutionDataSubjectDataArgs = {
  name: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};


/**
 * World University Ranking data related to a specific institution for a specific
 * year.
 */
export type WurInstitutionDataSubjectsDataArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  year: Scalars['Int']['input'];
};

export type WurMetric = {
  __typename?: 'WURMetric';
  /**
   * Returns the count, min, lower quartile, median, upper quartile and max
   * scores/ranks for the metric.
   *
   * Optionally takes a 'populationYear' which uses the institutions from the
   * provided yearly but substitutes in the current year's data.
   */
  aggregateData?: Maybe<WurAggregateData>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  resource: Scalars['ID']['output'];
  result?: Maybe<WurMetricScore>;
  results: Array<WurMetricScore>;
  shortName: Scalars['String']['output'];
  /**
   * The optimal way to format the score(s) belonging to this metric.
   *
   * e.g. percentage, currency.
   */
  valueType: WurValueType;
  weighting: Scalars['Float']['output'];
};


export type WurMetricAggregateDataArgs = {
  aggregateType?: InputMaybe<WurMetricAggregateType>;
  filter?: InputMaybe<WurAggregateFilterInput>;
  populationYear?: InputMaybe<Scalars['Int']['input']>;
};


export type WurMetricResultArgs = {
  institutionId: Scalars['String']['input'];
};


export type WurMetricResultsArgs = {
  filter?: InputMaybe<WurAggregateFilterInput>;
};

export enum WurMetricAggregateType {
  Score = 'SCORE',
  Value = 'VALUE'
}

export type WurMetricRes = {
  __typename?: 'WURMetricRes';
  aggregateData?: Maybe<WurAggregateData>;
  arrayOfCombinedResultObjects?: Maybe<Array<Maybe<WurMetricScore>>>;
  id?: Maybe<Scalars['ID']['output']>;
  results: Array<WurMetricScore>;
};


export type WurMetricResAggregateDataArgs = {
  aggregateType?: InputMaybe<WurMetricAggregateType>;
  filter?: InputMaybe<WurAggregateFilterInput>;
  populationYear?: InputMaybe<Scalars['Int']['input']>;
};


export type WurMetricResArrayOfCombinedResultObjectsArgs = {
  institutionId: Scalars['String']['input'];
};


export type WurMetricResResultsArgs = {
  filter?: InputMaybe<WurAggregateFilterInput>;
};

export type WurMetricScore = {
  __typename?: 'WURMetricScore';
  id: Scalars['ID']['output'];
  institution: WurInstitution;
  /**
   * A value isImputed if the institution haven't provided us with a concrete
   * score. In these cases THE offer up a value generated by our ranking
   * methodology.
   */
  isImputed: Scalars['Boolean']['output'];
  resource: Scalars['ID']['output'];
  score: Scalars['Float']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type WurMetricScoreRes = {
  __typename?: 'WURMetricScoreRes';
  id: Scalars['ID']['output'];
  institution: WurInstitution;
  /**
   * A value isImputed if the institution haven't provided us with a concrete
   * score. In these cases THE offer up a value generated by our ranking
   * methodology.
   */
  isImputed: Scalars['Boolean']['output'];
  resource: Scalars['ID']['output'];
  score: Scalars['Float']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type WurPillar = {
  __typename?: 'WURPillar';
  aggregateData?: Maybe<WurAggregateData>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  metric?: Maybe<WurMetric>;
  metrics: Array<WurMetric>;
  name: Scalars['String']['output'];
  resource: Scalars['ID']['output'];
  result?: Maybe<WurPillarScore>;
  results: Array<WurPillarScore>;
  shortName: Scalars['String']['output'];
  timeframe: Quarter;
};


export type WurPillarAggregateDataArgs = {
  filter?: InputMaybe<WurAggregateFilterInput>;
};


export type WurPillarMetricArgs = {
  name: Scalars['String']['input'];
};


export type WurPillarMetricsArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type WurPillarResultArgs = {
  institutionId: Scalars['String']['input'];
};


export type WurPillarResultsArgs = {
  input?: InputMaybe<WurAggregateFilterInput>;
};

export type WurPillarMetricRes = {
  __typename?: 'WURPillarMetricRes';
  id?: Maybe<Scalars['String']['output']>;
  metrics?: Maybe<WurMetricRes>;
};


export type WurPillarMetricResMetricsArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WurPillarMetrics = {
  __typename?: 'WURPillarMetrics';
  pillars?: Maybe<WurPillarMetricRes>;
};


export type WurPillarMetricsPillarsArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WurPillarOrderInput = {
  score?: InputMaybe<SortDirection>;
};

export type WurPillarScore = {
  __typename?: 'WURPillarScore';
  decile: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  institution: WurInstitution;
  rank: Scalars['Int']['output'];
  resource: Scalars['ID']['output'];
  score: Scalars['Float']['output'];
};

/** Represents a yearly data release for the World University Rankings. */
export type WurRelease = {
  __typename?: 'WURRelease';
  /**
   * Pre-defined list of bandings available for the World University Rankings.
   *
   * e.g. "25-50", "50-100", "100-200"
   */
  bandings: Array<WurBanding>;
  bibliometricSubject?: Maybe<WurBibliometricSubject>;
  bibliometricSubjects: Array<WurBibliometricSubject>;
  clusters: Array<WurReleaseCluster>;
  detailedSubject?: Maybe<WurDetailedSubject>;
  detailedSubjects: Array<WurDetailedSubject>;
  embargoEndDate: Scalars['String']['output'];
  embargoStartDate: Scalars['String']['output'];
  freeEmbargoStartDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  institutionData?: Maybe<WurInstitutionData>;
  institutionsData?: Maybe<WurReleaseInstitutions>;
  levelDefinitions?: Maybe<WurReleaseLevelDefinitions>;
  locations: DataPointsProductLocations;
  releaseDate: Scalars['String']['output'];
  resource: Scalars['ID']['output'];
  subject?: Maybe<WurSubject>;
  subjects: Array<WurSubject>;
  wurDetailsEmbargoStartDate: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};


/** Represents a yearly data release for the World University Rankings. */
export type WurReleaseBibliometricSubjectArgs = {
  name: Scalars['String']['input'];
  quarter: Quarter;
};


/** Represents a yearly data release for the World University Rankings. */
export type WurReleaseBibliometricSubjectsArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  quarters?: InputMaybe<Array<Quarter>>;
};


/** Represents a yearly data release for the World University Rankings. */
export type WurReleaseDetailedSubjectArgs = {
  name: Scalars['String']['input'];
};


/** Represents a yearly data release for the World University Rankings. */
export type WurReleaseDetailedSubjectsArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a yearly data release for the World University Rankings. */
export type WurReleaseInstitutionDataArgs = {
  id: Scalars['String']['input'];
};


/** Represents a yearly data release for the World University Rankings. */
export type WurReleaseInstitutionsDataArgs = {
  filter?: InputMaybe<WurAggregateFilterInput>;
};


/** Represents a yearly data release for the World University Rankings. */
export type WurReleaseSubjectArgs = {
  name: Scalars['String']['input'];
};


/** Represents a yearly data release for the World University Rankings. */
export type WurReleaseSubjectsArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * A pre-defined group of institutions that are selected internally at THE for each release.
 * e.g. "Old Stars", "Technology Challengers"
 */
export type WurReleaseCluster = {
  __typename?: 'WURReleaseCluster';
  bestRanked: Array<Maybe<WurSubjectResult>>;
  description?: Maybe<Scalars['String']['output']>;
  geographies: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  institutionCount: Scalars['Int']['output'];
  medianAge?: Maybe<Scalars['Int']['output']>;
  medianRank?: Maybe<WurBanding>;
  name: Scalars['String']['output'];
  resource: Scalars['ID']['output'];
  /** List of subject areas that this group of institutions are strongest in. */
  strengthsText: Scalars['String']['output'];
  /** List of subject areas that this group of institutions are weakest in. */
  weaknessesText: Scalars['String']['output'];
};

export type WurReleaseInstitutions = {
  __typename?: 'WURReleaseInstitutions';
  count: Scalars['Int']['output'];
  data: Array<WurInstitutionData>;
};

export type WurReleaseLevelDefinitions = {
  __typename?: 'WURReleaseLevelDefinitions';
  level1?: Maybe<Array<Maybe<WurReleaseLevelItemDefinition>>>;
  level2?: Maybe<Array<Maybe<WurReleaseLevelItemDefinition>>>;
  level3?: Maybe<Array<Maybe<WurReleaseLevelItemDefinition>>>;
};

export type WurReleaseLevelItemDefinition = {
  __typename?: 'WURReleaseLevelItemDefinition';
  levelId?: Maybe<Scalars['String']['output']>;
  longName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  rankingYear?: Maybe<Scalars['Int']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  weighting?: Maybe<Scalars['Float']['output']>;
};

export type WurReleaseMetric = {
  __typename?: 'WURReleaseMetric';
  /**
   * Pre-defined list of bandings available for the World University Rankings.
   *
   * e.g. "25-50", "50-100", "100-200"
   */
  bandings: Array<WurBanding>;
  bibliometricSubject?: Maybe<WurBibliometricSubject>;
  bibliometricSubjects: Array<WurBibliometricSubject>;
  clusters: Array<WurReleaseCluster>;
  detailedSubject?: Maybe<WurDetailedSubject>;
  detailedSubjects: Array<WurDetailedSubject>;
  embargoEndDate: Scalars['String']['output'];
  embargoStartDate: Scalars['String']['output'];
  freeEmbargoStartDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  institutionData?: Maybe<WurInstitutionData>;
  institutionsData?: Maybe<WurReleaseInstitutions>;
  levelDefinitions?: Maybe<WurReleaseLevelDefinitions>;
  locations: DataPointsProductLocations;
  releaseDate: Scalars['String']['output'];
  resource: Scalars['ID']['output'];
  subject?: Maybe<WurSubject>;
  subjects?: Maybe<WurPillarMetrics>;
  wurDetailsEmbargoStartDate: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};


export type WurReleaseMetricBibliometricSubjectArgs = {
  name: Scalars['String']['input'];
  quarter: Quarter;
};


export type WurReleaseMetricBibliometricSubjectsArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  quarters?: InputMaybe<Array<Quarter>>;
};


export type WurReleaseMetricDetailedSubjectArgs = {
  name: Scalars['String']['input'];
};


export type WurReleaseMetricDetailedSubjectsArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type WurReleaseMetricInstitutionDataArgs = {
  id: Scalars['String']['input'];
};


export type WurReleaseMetricInstitutionsDataArgs = {
  filter?: InputMaybe<WurAggregateFilterInput>;
};


export type WurReleaseMetricSubjectArgs = {
  name: Scalars['String']['input'];
};


export type WurReleaseMetricSubjectsArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WurSubject = {
  __typename?: 'WURSubject';
  aggregateData?: Maybe<WurAggregateData>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pillar?: Maybe<WurPillar>;
  pillars: Array<WurPillar>;
  resource: Scalars['ID']['output'];
  result?: Maybe<WurSubjectResult>;
  results: Array<WurSubjectResult>;
  shortName: Scalars['String']['output'];
};


export type WurSubjectAggregateDataArgs = {
  filter?: InputMaybe<WurAggregateFilterInput>;
};


export type WurSubjectPillarArgs = {
  isNewWur3Methodology?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};


export type WurSubjectPillarsArgs = {
  isNewWur3Methodology?: InputMaybe<Scalars['Boolean']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type WurSubjectResultArgs = {
  institutionId: Scalars['String']['input'];
};


export type WurSubjectResultsArgs = {
  input?: InputMaybe<WurAggregateFilterInput>;
};

export type WurSubjectData = {
  __typename?: 'WURSubjectData';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  numberOfBachelorsStudents?: Maybe<Scalars['Float']['output']>;
  numberOfDoctoratesStudents?: Maybe<Scalars['Float']['output']>;
  numberOfInternationalStaff?: Maybe<Scalars['Float']['output']>;
  numberOfInternationalStudents?: Maybe<Scalars['Float']['output']>;
  numberOfMastersStudents?: Maybe<Scalars['Float']['output']>;
  resource: Scalars['ID']['output'];
  subjectName: Scalars['String']['output'];
  totalAcademicStaff?: Maybe<Scalars['Float']['output']>;
  totalStudents?: Maybe<Scalars['Float']['output']>;
};

export type WurSubjectResult = {
  __typename?: 'WURSubjectResult';
  id: Scalars['ID']['output'];
  institution: WurInstitution;
  jointRanked: Scalars['Boolean']['output'];
  rank: WurBanding;
  resource: Scalars['ID']['output'];
  score: WurBanding;
  scoreNumber?: Maybe<Scalars['Float']['output']>;
  subject: WurSubject;
  year: Scalars['Int']['output'];
};

export enum WurValueType {
  Currency = 'CURRENCY',
  Elsevier = 'ELSEVIER',
  Na = 'NA',
  Percentage = 'PERCENTAGE',
  Portal = 'PORTAL',
  Reputation = 'REPUTATION',
  Untyped = 'UNTYPED'
}

export type GetRankDataQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  institutionId: Scalars['String']['input'];
  level1Id: Scalars['String']['input'];
  releaseName: Scalars['String']['input'];
  responseFields?: InputMaybe<Array<ResponseFieldsListItem> | ResponseFieldsListItem>;
}>;


export type GetRankDataQuery = { __typename?: 'Query', release: { __typename?: 'GRARelease', institutionData?: { __typename?: 'GRAInstitutionData', countryRank?: string | null } | null, level1: { __typename?: 'GRALevel1', result?: { __typename?: 'Level1Result', jointRanked: boolean, rank: { __typename?: 'GRABanding', higher: number, lower: number } } | null } } };

export type GetCitationScoreSubject_1QueryVariables = Exact<{
  years?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetCitationScoreSubject_1Query = { __typename?: 'Query', citations: Array<{ __typename?: 'WURPillar', id: string, name: string, timeframe: Quarter, results: Array<{ __typename?: 'WURPillarScore', id: string, score: number }> }> };

export type GetCitationScoreSubject_2QueryVariables = Exact<{
  years?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetCitationScoreSubject_2Query = { __typename?: 'Query', citations: Array<{ __typename?: 'WURPillar', id: string, name: string, timeframe: Quarter, results: Array<{ __typename?: 'WURPillarScore', id: string, score: number, rank: number }> }> };

export type GetCitationScoreSubject_3QueryVariables = Exact<{
  years?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetCitationScoreSubject_3Query = { __typename?: 'Query', citations: Array<{ __typename?: 'WURPillar', id: string, name: string, timeframe: Quarter, results: Array<{ __typename?: 'WURPillarScore', id: string, score: number, rank: number }> }> };

export type MockGetCitationScoreSubjectQueryVariables = Exact<{
  years?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type MockGetCitationScoreSubjectQuery = { __typename?: 'Query', citations: Array<{ __typename?: 'WURPillar', id: string, name: string, results: Array<{ __typename?: 'WURPillarScore', id: string, score: number, rank: number, institution: { __typename?: 'WURInstitution', name: string } }> }> };

export type InitialMyInstitutionsQueryVariables = Exact<{ [key: string]: never; }>;


export type InitialMyInstitutionsQuery = { __typename?: 'Query', myInstitutions: { __typename?: 'UserInstitutions', total: number, count: number, page: number, perPage: number, hasMore: boolean, search?: string | null, pages: number, institutions: Array<{ __typename?: 'UserInstitution', id: string, institutionId: string, name: string, products: Array<{ __typename?: 'DataPointsProduct', peersInfo: { __typename?: 'DataPointsProductPeersInfo', supportsPeers: boolean, supportsChangingPeers: boolean, peerChangeOpen: boolean, lastPeerChangeDate?: any | null, maxPeerCount: number, peerChangeIntervalWeeks: number } }> }> } };

export type InstitutionSetActiveInstitutionMutationVariables = Exact<{
  institutionId: Scalars['String']['input'];
}>;


export type InstitutionSetActiveInstitutionMutation = { __typename?: 'Mutation', setActiveInstitution?: { __typename?: 'UserInstitution', id: string, resource: string, institutionId: string, name: string, logo: string, country: string, countryCode: string, continent: string, insightsPreviewUrl?: string | null, products: Array<{ __typename?: 'DataPointsProduct', name: string, peersInfo: { __typename?: 'DataPointsProductPeersInfo', supportsPeers: boolean, supportsChangingPeers: boolean, peerChangeOpen: boolean, lastPeerChangeDate?: any | null, maxPeerCount: number, peerChangeIntervalWeeks: number, peerChangeDraft?: { __typename?: 'DataPointsPeerChangeDraft', userId: string, username: string, fullName?: string | null, institutionIds: Array<string>, peers?: Array<{ __typename?: 'DataPointsProductInstitution', id: string, institutionId: string, name: string, country: string, continent: string, logo: string }> | null } | null }, locations: { __typename?: 'DataPointsProductLocations', countries: Array<string>, continents: Array<string> }, institutionGroups: Array<{ __typename?: 'DataPointsProductInstitutionGroup', name: string, institutions: Array<{ __typename?: 'DataPointsProductInstitution', id: string, institutionId: string, name: string, country: string, continent: string, logo: string }> }> }> } | null };

export type SelectInstitutionMyInstitutionsQueryVariables = Exact<{
  search: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type SelectInstitutionMyInstitutionsQuery = { __typename?: 'Query', myInstitutions: { __typename?: 'UserInstitutions', total: number, count: number, page: number, perPage: number, hasMore: boolean, search?: string | null, pages: number, institutions: Array<{ __typename?: 'UserInstitution', id: string, institutionId: string, name: string, logo: string }> } };

export type WurDashboardPageQueryQueryVariables = Exact<{
  releaseNames: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  responseFields?: InputMaybe<Array<InputMaybe<ResponseFields2ListItem>> | InputMaybe<ResponseFields2ListItem>>;
}>;


export type WurDashboardPageQueryQuery = { __typename?: 'Query', releases: Array<{ __typename?: 'GRARelease', year: number, releaseDate: string, embargoEndDate: string, wurDetailsEmbargoStartDate: string, freeEmbargoStartDate: string, locations: { __typename?: 'GRADataPointsProductLocations', countries: Array<string>, continents: Array<string> } }> };

export type GetReleaseDatesQueryQueryVariables = Exact<{
  releaseNames: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  years?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;


export type GetReleaseDatesQueryQuery = { __typename?: 'Query', releaseDates?: Array<{ __typename?: 'GRAReleaseDate', year: number, datasetType: string, releaseDate: string, embargoedUntilDate: string, wurDetailsEmbargoedDate?: string | null, freeEmbargoedDate: string }> | null };

export type LegacyPermissionsQueryVariables = Exact<{
  institutionId: Scalars['String']['input'];
}>;


export type LegacyPermissionsQuery = { __typename?: 'Query', legacyPermissions: Array<{ __typename?: 'ResourcePermission', resource: string, actions: Array<{ __typename?: 'PermissionAction', action: string, grant: boolean }> }> };

export type PermissionsQueryVariables = Exact<{
  institutionId: Scalars['String']['input'];
}>;


export type PermissionsQuery = { __typename?: 'Query', permissions: Array<{ __typename?: 'ResourcePermission', resource: string, actions: Array<{ __typename?: 'PermissionAction', action: string, grant: boolean }> }> };

export type AvailableYearsQueryVariables = Exact<{
  releaseNames: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type AvailableYearsQuery = { __typename?: 'Query', releases: Array<{ __typename?: 'GRARelease', id: string, year: number, releaseDate: string }> };

export type GetBenchmarkSummaryBenchmarkStatisticsQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  releaseName: Scalars['String']['input'];
  responseFields?: InputMaybe<Array<InputMaybe<ResponseFieldsListItem>> | InputMaybe<ResponseFieldsListItem>>;
}>;


export type GetBenchmarkSummaryBenchmarkStatisticsQuery = { __typename?: 'Query', release: { __typename?: 'GRARelease', id: string, institutionsData?: { __typename?: 'InstitutionsData', data: Array<{ __typename?: 'GRAInstitutionData', institution: { __typename?: 'Institution', id: string, institutionId: string, name: string }, level1sData: Array<{ __typename?: 'SubjectData', id: string, name: string, numberOfBachelorsStudents: number, numberOfMastersStudents: number, numberOfDoctoratesStudents: number, numberOfInternationalStudents: number, totalStudents: number, numberOfInternationalStaff: number, totalAcademicStaff: number }> }> } | null } };

export type GetBenchmarkSummaryBenchmarkInstitutionsQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  level1Id: Scalars['String']['input'];
  releaseName: Scalars['String']['input'];
}>;


export type GetBenchmarkSummaryBenchmarkInstitutionsQuery = { __typename?: 'Query', release: { __typename?: 'GRARelease', id: string, level1: { __typename?: 'GRALevel1', id: string, results: Array<{ __typename?: 'Level1Result', id: string, jointRanked: boolean, institution: { __typename?: 'Institution', id: string, institutionId: string, name: string, country: string }, rank: { __typename?: 'GRABanding', lower: number, higher: number } }> } } };

export type GetBenchmarkSummaryPeersCardsQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  releaseName: Scalars['String']['input'];
  level1Id?: InputMaybe<Scalars['String']['input']>;
  responseFields?: InputMaybe<Array<InputMaybe<ResponseFieldsListItem>> | InputMaybe<ResponseFieldsListItem>>;
}>;


export type GetBenchmarkSummaryPeersCardsQuery = { __typename?: 'Query', release: { __typename?: 'GRARelease', id: string, totalRankedInstitutions: number, level1: { __typename?: 'GRALevel1', id: string, level2s: Array<{ __typename?: 'GRALevel2', id: string, name: string, results: Array<{ __typename?: 'Level2Result', score: number, rank: number, decile?: number | null, institution: { __typename?: 'Institution', id: string, institutionId: string } }> }>, results: Array<{ __typename?: 'Level1Result', jointRanked: boolean, institution: { __typename?: 'Institution', id: string, institutionId: string, name: string }, rank: { __typename?: 'GRABanding', lower: number, higher: number } }> }, institutionsData?: { __typename?: 'InstitutionsData', count: number, data: Array<{ __typename?: 'GRAInstitutionData', id: string, totalStudents: number, studentToStaffPercentage: number, femaleStudentPercentage: number, internationalStudentPercentage: number, institutionsInCountryCount: number, countryRank?: string | null, institution: { __typename?: 'Institution', id: string, institutionId: string, name: string, country: string } }> } | null } };

export type GetBibliometricAnalysisPageDetailsQueryVariables = Exact<{
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  releaseNames: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  responseFields?: InputMaybe<Array<InputMaybe<ResponseFields2ListItem>> | InputMaybe<ResponseFields2ListItem>>;
}>;


export type GetBibliometricAnalysisPageDetailsQuery = { __typename?: 'Query', releases: Array<{ __typename?: 'GRARelease', year: number, bibliometricSubjects?: Array<{ __typename?: 'BibliometricSubject', key: string, name: string, aggregateData: { __typename?: 'AggregateData', max: number } }> | null }> };

export type GetBibliometricScoresQueryVariables = Exact<{
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  releaseNames: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  responseFields?: InputMaybe<Array<InputMaybe<ResponseFields2ListItem>> | InputMaybe<ResponseFields2ListItem>>;
  years?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  bibliometricSubjectIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBibliometricScoresQuery = { __typename?: 'Query', releases: Array<{ __typename?: 'GRARelease', id: string, year: number, bibliometricSubjects?: Array<{ __typename?: 'BibliometricSubject', id: string, key: string, name: string, timeframe?: GraQuarter | null, results: Array<{ __typename?: 'BibliometricResult', id: string, citation: number, institution: { __typename?: 'Institution', id: string, institutionId: string, name: string } }>, aggregateData: { __typename?: 'AggregateData', max: number, min: number, median: number, lowerQuartile: number, upperQuartile: number } }> | null }> };

export type AcceptDataPlusEmbargoMutationVariables = Exact<{
  institutionId: Scalars['String']['input'];
  year: Scalars['Int']['input'];
  dataset: Scalars['String']['input'];
  productName: Scalars['String']['input'];
}>;


export type AcceptDataPlusEmbargoMutation = { __typename?: 'Mutation', acceptEmbargo: Array<{ __typename?: 'ResourcePermission', resource: string, actions: Array<{ __typename?: 'PermissionAction', action: string, grant: boolean }> }> };

export type GetGraDetailedSubjectsPageDetailsQueryVariables = Exact<{
  releaseNames: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  responseFields?: InputMaybe<Array<InputMaybe<ResponseFields2ListItem>> | InputMaybe<ResponseFields2ListItem>>;
}>;


export type GetGraDetailedSubjectsPageDetailsQuery = { __typename?: 'Query', releases: Array<{ __typename?: 'GRARelease', year: number, detailedSubjects: Array<{ __typename?: 'DetailedSubject', key: string, name: string, shortName: string, level3s: Array<{ __typename?: 'GRALevel3', key: string, name: string }> }> }> };

export type GetInstitutionHasPriorYearDataQueryVariables = Exact<{
  releaseNames: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  years?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  responseFields?: InputMaybe<Array<InputMaybe<ResponseFields2ListItem>> | InputMaybe<ResponseFields2ListItem>>;
}>;


export type GetInstitutionHasPriorYearDataQuery = { __typename?: 'Query', releases: Array<{ __typename?: 'GRARelease', year: number, detailedSubjects: Array<{ __typename?: 'DetailedSubject', results: Array<{ __typename?: 'Result', institution: { __typename?: 'Institution', institutionId: string } }> }> }> };

export type GetOverallDetailedSubjectScoresQueryVariables = Exact<{
  years?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  detailedSubjectIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  region: Scalars['String']['input'];
  releaseNames: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  responseFields?: InputMaybe<Array<InputMaybe<ResponseFields2ListItem>> | InputMaybe<ResponseFields2ListItem>>;
}>;


export type GetOverallDetailedSubjectScoresQuery = { __typename?: 'Query', releases: Array<{ __typename?: 'GRARelease', year: number, detailedSubjects: Array<{ __typename?: 'DetailedSubject', id: string, resource: string, key: string, name: string, shortName: string, results: Array<{ __typename?: 'Result', score: number, institution: { __typename?: 'Institution', institutionId: string, name: string } }>, aggregateData: { __typename?: 'AggregateData', max: number, min: number, median: number, lowerQuartile: number, upperQuartile: number } }> }> };

export type GetDetailedSubjectMetricScoresQueryVariables = Exact<{
  years?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  detailedSubjectIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  region: Scalars['String']['input'];
  releaseNames: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  responseFields?: InputMaybe<Array<InputMaybe<ResponseFields2ListItem>> | InputMaybe<ResponseFields2ListItem>>;
  detailedSubjectMetricIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetDetailedSubjectMetricScoresQuery = { __typename?: 'Query', releases: Array<{ __typename?: 'GRARelease', year: number, institutionsData?: { __typename?: 'InstitutionsData', data: Array<{ __typename?: 'GRAInstitutionData', institution: { __typename?: 'Institution', name: string, institutionId: string } }> } | null, detailedSubjects: Array<{ __typename?: 'DetailedSubject', id: string, resource: string, key: string, name: string, shortName: string, level3s: Array<{ __typename?: 'GRALevel3', id: string, key: string, name: string, valueType: ValueType, results: Array<{ __typename?: 'Result', score: number, institution: { __typename?: 'Institution', institutionId: string, name: string } }>, aggregateData: { __typename?: 'AggregateData', max: number, min: number, median: number, lowerQuartile: number, upperQuartile: number } }> }> }> };

export type GetSubjectAndClusterNamesQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  releaseName: Scalars['String']['input'];
  responseFields?: InputMaybe<Array<ResponseFieldsListItem> | ResponseFieldsListItem>;
}>;


export type GetSubjectAndClusterNamesQuery = { __typename?: 'Query', release: { __typename?: 'GRARelease', level1s: Array<{ __typename?: 'GRALevel1', name: string }>, clusters: Array<{ __typename?: 'GRACluster', name: string }> } };

export type GetProductPeersDraftQueryVariables = Exact<{
  institutionId: Scalars['String']['input'];
}>;


export type GetProductPeersDraftQuery = { __typename?: 'Query', getProductPeersDraft?: { __typename?: 'DataPointsPeerChangeDraft', userId: string, peers?: Array<{ __typename?: 'DataPointsProductInstitution', id: string, institutionId: string, name: string, country: string, continent: string, logo: string }> | null } | null };

export type SetSelectedPeersMutationVariables = Exact<{
  peerIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  institutionId: Scalars['String']['input'];
  productName: Scalars['String']['input'];
}>;


export type SetSelectedPeersMutation = { __typename?: 'Mutation', setProductPeers: Array<{ __typename?: 'DataPointsProductInstitution', id: string, institutionId: string, name: string, country: string, continent: string, logo: string }> };

export type SetSelectedPeersDraftMutationVariables = Exact<{
  peerIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  institutionId: Scalars['String']['input'];
  productName: Scalars['String']['input'];
}>;


export type SetSelectedPeersDraftMutation = { __typename?: 'Mutation', setProductPeersDraft?: { __typename?: 'DataPointsPeerChangeDraft', username: string, institutionIds: Array<string> } | null };

export type GetAllRankedInstitutionsQueryVariables = Exact<{
  releaseName: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  year: Scalars['Int']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  excludeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  institutionName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  level1s?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  clusters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  lowerOverallRank?: InputMaybe<Scalars['Float']['input']>;
  upperOverallRank?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetAllRankedInstitutionsQuery = { __typename?: 'Query', allRankedInstitutions: { __typename?: 'AllRankedInstitutions', total: number, count: number, page: number, perPage: number, hasMore: boolean, pages: number, institutions: Array<{ __typename?: 'AllRankedInstitutionsData', id: string, name: string, institutionId: string, logo: string, country: string, founded?: number | null, results?: Array<{ __typename?: 'AllRankedInstitutionsDataResult', jointRanked: boolean, year: number, rank: { __typename?: 'GRABanding', lower: number, higher: number }, level1: { __typename?: 'AllRankedInstitutionsResultLevel1', key: string, name: string } }> | null, institutionData?: { __typename?: 'AllRankedInstitutionsDataInstitutions', totalStudents: number, totalStaff: number, cluster?: { __typename?: 'Cluster', name: string } | null } | null }> } };

export type GetOverallLevel1ResultsForInstitutionsQueryVariables = Exact<{
  years?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  releaseNames: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  level1Id: Scalars['String']['input'];
  responseFields?: InputMaybe<Array<InputMaybe<ResponseFields2ListItem>> | InputMaybe<ResponseFields2ListItem>>;
}>;


export type GetOverallLevel1ResultsForInstitutionsQuery = { __typename?: 'Query', releases: Array<{ __typename?: 'GRARelease', year: number, level1: { __typename?: 'GRALevel1', results: Array<{ __typename?: 'Level1Result', jointRanked: boolean, rank: { __typename?: 'GRABanding', lower: number, higher: number }, institution: { __typename?: 'Institution', institutionId: string } }> } }> };

export type GetNewWurMetricsComparisonQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  institutionId: Scalars['String']['input'];
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  releaseName: Scalars['String']['input'];
  level1Id: Scalars['String']['input'];
  responseFields?: InputMaybe<Array<ResponseFieldsListItem> | ResponseFieldsListItem>;
}>;


export type GetNewWurMetricsComparisonQuery = { __typename?: 'Query', release: { __typename?: 'GRARelease', level1: { __typename?: 'GRALevel1', id: string, level2s: Array<{ __typename?: 'GRALevel2', id: string, name: string, level3s: Array<{ __typename?: 'GRALevel3', id: string, name: string, valueType: ValueType, result: { __typename?: 'Result', id: string, score: number, value: number, isImputed?: boolean | null, institution: { __typename?: 'Institution', id: string, institutionId: string } }, results: Array<{ __typename?: 'Result', id: string, score: number, value: number, isImputed?: boolean | null, institution: { __typename?: 'Institution', id: string, institutionId: string } }> }> }>, result?: { __typename?: 'Level1Result', id: string, rank: { __typename?: 'GRABanding', lower: number, higher: number } } | null }, institutionData?: { __typename?: 'GRAInstitutionData', pppToUsd: number, institution: { __typename?: 'Institution', name: string, id: string, institutionId: string } } | null, institutionsData?: { __typename?: 'InstitutionsData', data: Array<{ __typename?: 'GRAInstitutionData', pppToUsd: number, institution: { __typename?: 'Institution', name: string, id: string, institutionId: string } }> } | null } };

export type GetNewWurMetricsOveralScoresQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  institutionId: Scalars['String']['input'];
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  releaseName: Scalars['String']['input'];
  level1Id: Scalars['String']['input'];
  responseFields?: InputMaybe<Array<ResponseFieldsListItem> | ResponseFieldsListItem>;
}>;


export type GetNewWurMetricsOveralScoresQuery = { __typename?: 'Query', release: { __typename?: 'GRARelease', id: string, level1: { __typename?: 'GRALevel1', id: string, level2s: Array<{ __typename?: 'GRALevel2', id: string, key: string, name: string, level3s: Array<{ __typename?: 'GRALevel3', id: string, key: string, name: string, valueType: ValueType, aggregateValueData: { __typename?: 'AggregateData', min: number, lowerQuartile: number, median: number, upperQuartile: number, max: number }, aggregateScoreData: { __typename?: 'AggregateData', min: number, lowerQuartile: number, median: number, upperQuartile: number, max: number }, result: { __typename?: 'Result', id: string, score: number, value: number, pppValue?: number | null, isImputed?: boolean | null, institution: { __typename?: 'Institution', id: string, institutionId: string } }, results: Array<{ __typename?: 'Result', id: string, score: number, value: number, isImputed?: boolean | null, institution: { __typename?: 'Institution', id: string, name: string, institutionId: string } }> }> }>, result?: { __typename?: 'Level1Result', id: string, rank: { __typename?: 'GRABanding', lower: number, higher: number } } | null }, institutionData?: { __typename?: 'GRAInstitutionData', pppToUsd: number, currency: string, institution: { __typename?: 'Institution', name: string, id: string, institutionId: string } } | null, institutionsData?: { __typename?: 'InstitutionsData', data: Array<{ __typename?: 'GRAInstitutionData', pppToUsd: number, currency: string, institution: { __typename?: 'Institution', name: string, id: string, institutionId: string } }> } | null } };

export type GetNewLevelDefinitionsQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  institutionId: Scalars['String']['input'];
  level1Id: Scalars['String']['input'];
  releaseName: Scalars['String']['input'];
  responseFields?: InputMaybe<Array<ResponseFieldsListItem> | ResponseFieldsListItem>;
}>;


export type GetNewLevelDefinitionsQuery = { __typename?: 'Query', release: { __typename?: 'GRARelease', levelDefinitions?: { __typename?: 'GRAReleaseLevelDefinitions', level2?: Array<{ __typename?: 'GRAReleaseLevelItemDefinition', parentId?: string | null, levelId?: string | null, shortName?: string | null, name?: string | null, weighting?: number | null, type?: string | null, rankingYear?: number | null } | null> | null, level3?: Array<{ __typename?: 'GRAReleaseLevelItemDefinition', parentId?: string | null, levelId?: string | null, shortName?: string | null, name?: string | null, weighting?: number | null, type?: string | null, rankingYear?: number | null } | null> | null } | null } };

export type GetChangeOverYearQueryVariables = Exact<{
  years?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  institutionId: Scalars['String']['input'];
  releaseNames: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  level1Id: Scalars['String']['input'];
  responseFields?: InputMaybe<Array<InputMaybe<ResponseFields2ListItem>> | InputMaybe<ResponseFields2ListItem>>;
}>;


export type GetChangeOverYearQuery = { __typename?: 'Query', releases: Array<{ __typename?: 'GRARelease', id: string, year: number, level1: { __typename?: 'GRALevel1', id: string, result?: { __typename?: 'Level1Result', jointRanked: boolean, rank: { __typename?: 'GRABanding', lower: number, higher: number } } | null } }> };

export type GetOverviewPerformanceQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  institutionId: Scalars['String']['input'];
  releaseName: Scalars['String']['input'];
  level1Id: Scalars['String']['input'];
  responseFields?: InputMaybe<Array<ResponseFieldsListItem> | ResponseFieldsListItem>;
}>;


export type GetOverviewPerformanceQuery = { __typename?: 'Query', release: { __typename?: 'GRARelease', id: string, institutionData?: { __typename?: 'GRAInstitutionData', currency: string, pppToUsd: number } | null, level1: { __typename?: 'GRALevel1', id: string, level2s: Array<{ __typename?: 'GRALevel2', id: string, name: string, result: { __typename?: 'Level2Result', score: number, rank: number }, aggregateData: { __typename?: 'AggregateData', count: number, max: number, upperQuartile: number, median: number, lowerQuartile: number, min: number }, level3s: Array<{ __typename?: 'GRALevel3', id: string, name: string, valueType: ValueType, result: { __typename?: 'Result', score: number, value: number, isImputed?: boolean | null, reportedValue?: number | null } }> }> } } };

export type GetOverviewPillarScoresQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  institutionId: Scalars['String']['input'];
  level1Id: Scalars['String']['input'];
  releaseName: Scalars['String']['input'];
  region: Scalars['String']['input'];
  responseFields?: InputMaybe<Array<ResponseFieldsListItem> | ResponseFieldsListItem>;
}>;


export type GetOverviewPillarScoresQuery = { __typename?: 'Query', release: { __typename?: 'GRARelease', id: string, level1: { __typename?: 'GRALevel1', id: string, level2s: Array<{ __typename?: 'GRALevel2', id: string, name: string, key: string, result: { __typename?: 'Level2Result', score: number, rank: number }, aggregateData: { __typename?: 'AggregateData', count: number, max: number, upperQuartile: number, median: number, lowerQuartile: number, min: number } }> } } };

export type GetOverviewSummaryQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  institutionId: Scalars['String']['input'];
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  level1Id: Scalars['String']['input'];
  releaseName: Scalars['String']['input'];
  responseFields?: InputMaybe<Array<ResponseFieldsListItem> | ResponseFieldsListItem>;
}>;


export type GetOverviewSummaryQuery = { __typename?: 'Query', release: { __typename?: 'GRARelease', id: string, totalRankedInstitutions: number, institutionData?: { __typename?: 'GRAInstitutionData', countryRank?: string | null, institutionsInCountryCount: number, institution: { __typename?: 'Institution', country: string } } | null, level1: { __typename?: 'GRALevel1', id: string, level2s: Array<{ __typename?: 'GRALevel2', id: string, name: string, result: { __typename?: 'Level2Result', score: number, rank: number } }>, result?: { __typename?: 'Level1Result', jointRanked: boolean, score: { __typename?: 'GRABanding', higher: number, lower: number }, rank: { __typename?: 'GRABanding', higher: number, lower: number } } | null } } };

export type GetPeerGroupAnalysisTableQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  institutionId: Scalars['String']['input'];
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  releaseName: Scalars['String']['input'];
  responseFields?: InputMaybe<Array<ResponseFieldsListItem> | ResponseFieldsListItem>;
}>;


export type GetPeerGroupAnalysisTableQuery = { __typename?: 'Query', release: { __typename?: 'GRARelease', institutionData?: { __typename?: 'GRAInstitutionData', institution: { __typename?: 'Institution', id: string, institutionId: string, name: string }, cluster: { __typename?: 'GRACluster', id: string, name: string } } | null, institutionsData?: { __typename?: 'InstitutionsData', data: Array<{ __typename?: 'GRAInstitutionData', institution: { __typename?: 'Institution', id: string, institutionId: string, name: string }, cluster: { __typename?: 'GRACluster', id: string, name: string } }> } | null } };

export type GetPeerGroupAnalysisCardsQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  releaseName: Scalars['String']['input'];
  responseFields?: InputMaybe<Array<ResponseFieldsListItem> | ResponseFieldsListItem>;
}>;


export type GetPeerGroupAnalysisCardsQuery = { __typename?: 'Query', release: { __typename?: 'GRARelease', clusters: Array<{ __typename?: 'GRACluster', id: string, name: string, description?: string | null, institutionCount?: number | null, geographies: Array<string>, medianAge?: number | null, strengthsText?: string | null, weaknessesText?: string | null, medianRank?: { __typename?: 'GRABanding', lower: number, higher: number } | null, bestRanked: Array<{ __typename?: 'BestRank', institution: { __typename?: 'Institution', name: string, country: string }, rank?: { __typename?: 'GRABanding', lower: number, higher: number } | null } | null> }> } };

export type NewReleasePillarsQueryVariables = Exact<{
  institutionId: Scalars['String']['input'];
  year: Scalars['Int']['input'];
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  region: Scalars['String']['input'];
  level1Id: Scalars['String']['input'];
  releaseName: Scalars['String']['input'];
  responseFields?: InputMaybe<Array<InputMaybe<ResponseFieldsListItem>> | InputMaybe<ResponseFieldsListItem>>;
}>;


export type NewReleasePillarsQuery = { __typename?: 'Query', release: { __typename?: 'GRARelease', id: string, level1: { __typename?: 'GRALevel1', level2s: Array<{ __typename?: 'GRALevel2', id: string, name: string, aggregateData: { __typename?: 'AggregateData', min: number, lowerQuartile: number, median: number, upperQuartile: number, max: number }, result: { __typename?: 'Level2Result', id: string, score: number }, results: Array<{ __typename?: 'Level2Result', id: string, score: number, institution: { __typename?: 'Institution', id: string, institutionId: string, name: string } }> }> } } };

export type NewReleaseCrossPillarsQueryVariables = Exact<{
  institutionId: Scalars['String']['input'];
  year: Scalars['Int']['input'];
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  level1Id: Scalars['String']['input'];
  releaseName: Scalars['String']['input'];
  responseFields?: InputMaybe<Array<InputMaybe<ResponseFieldsListItem>> | InputMaybe<ResponseFieldsListItem>>;
}>;


export type NewReleaseCrossPillarsQuery = { __typename?: 'Query', release: { __typename?: 'GRARelease', id: string, level1: { __typename?: 'GRALevel1', level2s: Array<{ __typename?: 'GRALevel2', id: string, name: string, result: { __typename?: 'Level2Result', id: string, score: number }, results: Array<{ __typename?: 'Level2Result', id: string, score: number, institution: { __typename?: 'Institution', id: string, institutionId: string, name: string } }> }> } } };

export type NewReleaseIndividualSubjectQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  institutionId: Scalars['String']['input'];
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  level1Id: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  releaseName: Scalars['String']['input'];
  responseFields?: InputMaybe<Array<ResponseFieldsListItem> | ResponseFieldsListItem>;
}>;


export type NewReleaseIndividualSubjectQuery = { __typename?: 'Query', release: { __typename?: 'GRARelease', level1: { __typename?: 'GRALevel1', key: string, name: string, level2s: Array<{ __typename?: 'GRALevel2', id: string, name: string, level3s: Array<{ __typename?: 'GRALevel3', id: string, name: string, key: string, valueType: ValueType, aggregateScoreData: { __typename?: 'AggregateData', count: number, min: number, lowerQuartile: number, median: number, upperQuartile: number, max: number }, result: { __typename?: 'Result', id: string, score: number, value: number, isImputed?: boolean | null, institution: { __typename?: 'Institution', id: string, institutionId: string, name: string } }, results: Array<{ __typename?: 'Result', isImputed?: boolean | null, score: number, value: number, institution: { __typename?: 'Institution', id: string, institutionId: string, name: string } }> }> }> }, level1s: Array<{ __typename?: 'GRALevel1', key: string, name: string }>, institutionData?: { __typename?: 'GRAInstitutionData', pppToUsd: number, institution: { __typename?: 'Institution', name: string, id: string, institutionId: string } } | null, institutionsData?: { __typename?: 'InstitutionsData', data: Array<{ __typename?: 'GRAInstitutionData', pppToUsd: number, institution: { __typename?: 'Institution', name: string, id: string, institutionId: string } }> } | null } };

export type NewReleaseSubjectsQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  institutionId: Scalars['String']['input'];
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  level1Id: Scalars['String']['input'];
  releaseName: Scalars['String']['input'];
  responseFields?: InputMaybe<Array<ResponseFieldsListItem> | ResponseFieldsListItem>;
}>;


export type NewReleaseSubjectsQuery = { __typename?: 'Query', release: { __typename?: 'GRARelease', level1: { __typename?: 'GRALevel1', result?: { __typename?: 'Level1Result', rank: { __typename?: 'GRABanding', lower: number, higher: number } } | null }, level1s: Array<{ __typename?: 'GRALevel1', id: string, name: string, results: Array<{ __typename?: 'Level1Result', scoreNumber: number, institution: { __typename?: 'Institution', id: string, institutionId: string, name: string } }> }> } };

export type GetYearOnYearChangesInPerformanceQueryVariables = Exact<{
  years?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  releaseNames: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  level1Id: Scalars['String']['input'];
  responseFields?: InputMaybe<Array<InputMaybe<ResponseFields2ListItem>> | InputMaybe<ResponseFields2ListItem>>;
}>;


export type GetYearOnYearChangesInPerformanceQuery = { __typename?: 'Query', releases: Array<{ __typename?: 'GRARelease', id: string, year: number, level1: { __typename?: 'GRALevel1', id: string, results: Array<{ __typename?: 'Level1Result', id: string, scoreNumber: number, jointRanked: boolean, institution: { __typename?: 'Institution', name: string, id: string, institutionId: string }, rank: { __typename?: 'GRABanding', lower: number, higher: number }, score: { __typename?: 'GRABanding', lower: number, higher: number } }> } }> };

export type GetYearOnYearContributingFactorsQueryVariables = Exact<{
  years?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  institutionId: Scalars['String']['input'];
  peerInstitutionId: Scalars['String']['input'];
  releaseNames: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  level1Id: Scalars['String']['input'];
  responseFields?: InputMaybe<Array<InputMaybe<ResponseFields2ListItem>> | InputMaybe<ResponseFields2ListItem>>;
}>;


export type GetYearOnYearContributingFactorsQuery = { __typename?: 'Query', releases: Array<{ __typename?: 'GRARelease', id: string, year: number, level1: { __typename?: 'GRALevel1', id: string, result?: { __typename?: 'Level1Result', id: string, scoreNumber: number, score: { __typename?: 'GRABanding', lower: number } } | null, level2s: Array<{ __typename?: 'GRALevel2', id: string, name: string, level3s: Array<{ __typename?: 'GRALevel3', id: string, name: string, weighting: number, key: string, result: { __typename?: 'Result', id: string, score: number } }> }> } }> };

export type GetYearOnYearPerformanceDistributionQueryVariables = Exact<{
  years?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  institutionId: Scalars['String']['input'];
  releaseNames: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  level1Id: Scalars['String']['input'];
  region: Scalars['String']['input'];
  responseFields?: InputMaybe<Array<InputMaybe<ResponseFields2ListItem>> | InputMaybe<ResponseFields2ListItem>>;
}>;


export type GetYearOnYearPerformanceDistributionQuery = { __typename?: 'Query', releases: Array<{ __typename?: 'GRARelease', id: string, year: number, level1: { __typename?: 'GRALevel1', id: string, level2s: Array<{ __typename?: 'GRALevel2', id: string, level3s: Array<{ __typename?: 'GRALevel3', id: string, name: string, key: string, result: { __typename?: 'Result', id: string, score: number }, aggregateScoreData: { __typename?: 'AggregateData', min: number, median: number, lowerQuartile: number, upperQuartile: number, max: number }, aggregateScorePerformanceData: { __typename?: 'AggregateData', min: number, median: number, lowerQuartile: number, upperQuartile: number, max: number } }> }> } }> };

export type AddScenarioMutationVariables = Exact<{
  input: ScenarioDataInput;
}>;


export type AddScenarioMutation = { __typename?: 'Mutation', addScenario: { __typename?: 'ScenarioMutationResult', scenarioId: string } };

export type WurReporterInterimAddScenarioMutationVariables = Exact<{
  input: ScenarioDataInput;
}>;


export type WurReporterInterimAddScenarioMutation = { __typename?: 'Mutation', wurReporterInterimAddScenario: { __typename?: 'ScenarioMutationResult', scenarioId: string } };

export type SubmissionWur2QueryVariables = Exact<{
  institutionId: Scalars['String']['input'];
  year: Scalars['Int']['input'];
}>;


export type SubmissionWur2Query = { __typename?: 'Query', institution?: { __typename?: 'WURInstitution', currency: string } | null, submission?: { __typename?: 'Submission', institutionId: string, year: number, overall?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null, artsAndHumanities?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null, businessAndEconomics?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null, clinicalAndHealth?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null, computerScience?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null, education?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null, engineering?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null, law?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null, lifeSciences?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null, physicalSciences?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null, psychology?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null, socialSciences?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null } | null };

export type SubmissionWur3QueryVariables = Exact<{
  institutionId: Scalars['String']['input'];
  year: Scalars['Int']['input'];
}>;


export type SubmissionWur3Query = { __typename?: 'Query', institution?: { __typename?: 'WURInstitution', currency: string } | null, submission?: { __typename?: 'Submission', institutionId: string, year: number, overall?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null, artsAndHumanities?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null, businessAndEconomics?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null, clinicalAndHealth?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null, computerScience?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null, education?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null, engineering?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null, law?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null, lifeSciences?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null, physicalSciences?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null, psychology?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null, socialSciences?: { __typename?: 'SubmissionsSubjectField', applicable?: boolean | null } | null } | null };

export type EditScenarioMutationVariables = Exact<{
  scenarioId: Scalars['String']['input'];
  input: ScenarioDataInput;
}>;


export type EditScenarioMutation = { __typename?: 'Mutation', editScenario: { __typename?: 'Scenario', scenarioId: string, name: string } };

export type WurReporterInterimEditScenarioMutationVariables = Exact<{
  scenarioId: Scalars['String']['input'];
  input: ScenarioDataInput;
}>;


export type WurReporterInterimEditScenarioMutation = { __typename?: 'Mutation', wurReporterInterimEditScenario: { __typename?: 'Scenario', scenarioId: string, name: string } };

export type EditScenarioNameMutationVariables = Exact<{
  scenarioId: Scalars['String']['input'];
  input: ScenarioDataInput;
}>;


export type EditScenarioNameMutation = { __typename?: 'Mutation', editScenario: { __typename?: 'Scenario', scenarioId: string } };

export type WurReporterInterimEditScenarioNameMutationVariables = Exact<{
  scenarioId: Scalars['String']['input'];
  input: ScenarioDataInput;
}>;


export type WurReporterInterimEditScenarioNameMutation = { __typename?: 'Mutation', wurReporterInterimEditScenario: { __typename?: 'Scenario', scenarioId: string } };

export type ScenariosQueryVariables = Exact<{
  perPage?: InputMaybe<Scalars['Int']['input']>;
  institutionId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  allowScoresForExcluded: Scalars['Boolean']['input'];
}>;


export type ScenariosQuery = { __typename?: 'Query', scenarios?: Array<{ __typename?: 'Scenario', scenarioId: string, name: string, methodology: string, createdAt: any, updatedAt: any, archived?: any | null, totalScenariosCount: number, alexanderJson: { __typename?: 'ScenarioResult', overall?: { __typename?: 'ScenarioResultFields', scoreDisplay?: string | null, rankDisplay?: string | null } | null } }> | null };

export type WurReporterInterimScenariosQueryVariables = Exact<{
  perPage?: InputMaybe<Scalars['Int']['input']>;
  institutionId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  allowScoresForExcluded: Scalars['Boolean']['input'];
}>;


export type WurReporterInterimScenariosQuery = { __typename?: 'Query', wurReporterInterimScenarios?: Array<{ __typename?: 'Scenario', scenarioId: string, name: string, methodology: string, createdAt: any, updatedAt: any, archived?: any | null, totalScenariosCount: number, alexanderJson: { __typename?: 'ScenarioResult', overall?: { __typename?: 'ScenarioResultFields', scoreDisplay?: string | null, rankDisplay?: string | null } | null } }> | null };

export type ArchiveScenariosMutationVariables = Exact<{
  scenarioIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  institutionId: Scalars['String']['input'];
}>;


export type ArchiveScenariosMutation = { __typename?: 'Mutation', archiveScenarios: { __typename?: 'ScenarioMutationResult', resource: string } };

export type WurReporterInterimArchiveScenariosMutationVariables = Exact<{
  scenarioIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  institutionId: Scalars['String']['input'];
  allowScoresForExcluded: Scalars['Boolean']['input'];
}>;


export type WurReporterInterimArchiveScenariosMutation = { __typename?: 'Mutation', wurReporterInterimArchiveScenarios: { __typename?: 'ScenarioMutationResult', resource: string } };

export type UnarchiveScenariosMutationVariables = Exact<{
  scenarioIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  institutionId: Scalars['String']['input'];
}>;


export type UnarchiveScenariosMutation = { __typename?: 'Mutation', unarchiveScenarios: { __typename?: 'ScenarioMutationResult', resource: string } };

export type WurReporterInterimUnarchiveScenariosMutationVariables = Exact<{
  scenarioIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  institutionId: Scalars['String']['input'];
  allowScoresForExcluded: Scalars['Boolean']['input'];
}>;


export type WurReporterInterimUnarchiveScenariosMutation = { __typename?: 'Mutation', wurReporterInterimUnarchiveScenarios: { __typename?: 'ScenarioMutationResult', resource: string } };

export type GetWurRatingAndScoreQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  institutionId: Scalars['String']['input'];
}>;


export type GetWurRatingAndScoreQuery = { __typename?: 'Query', wurRelease?: { __typename?: 'WURRelease', subject?: { __typename?: 'WURSubject', result?: { __typename?: 'WURSubjectResult', score: { __typename?: 'WURBanding', higher: number, lower: number }, rank: { __typename?: 'WURBanding', higher: number, lower: number } } | null } | null } | null };

export type GetWurPillarsComparisonQueryVariables = Exact<{
  myId: Scalars['String']['input'];
  year: Scalars['Int']['input'];
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  region: Scalars['String']['input'];
  isNewWur3Methodology?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetWurPillarsComparisonQuery = { __typename?: 'Query', wurRelease?: { __typename?: 'WURRelease', id: string, levelDefinitions?: { __typename?: 'WURReleaseLevelDefinitions', level2?: Array<{ __typename?: 'WURReleaseLevelItemDefinition', parentId?: string | null, levelId?: string | null, shortName?: string | null, longName?: string | null, name?: string | null, weighting?: number | null, type?: string | null } | null> | null, level3?: Array<{ __typename?: 'WURReleaseLevelItemDefinition', parentId?: string | null, levelId?: string | null, shortName?: string | null, longName?: string | null, name?: string | null, weighting?: number | null, type?: string | null } | null> | null } | null, subject?: { __typename?: 'WURSubject', pillars: Array<{ __typename?: 'WURPillar', id: string, name: string, key: string, aggregateData?: { __typename?: 'WURAggregateData', min: number, lowerQuartile: number, median: number, upperQuartile: number, max: number } | null, result?: { __typename?: 'WURPillarScore', id: string, score: number } | null, results: Array<{ __typename?: 'WURPillarScore', id: string, score: number, institution: { __typename?: 'WURInstitution', id: string, institutionId: string, name: string } }> }> } | null } | null };

export type NewReleaseQueryVariables = Exact<{
  myId: Scalars['String']['input'];
  year: Scalars['Int']['input'];
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  region: Scalars['String']['input'];
}>;


export type NewReleaseQuery = { __typename?: 'Query', newrelease?: { __typename?: 'GRARelease', id: string, levelDefinitions?: { __typename?: 'GRAReleaseLevelDefinitions', level2?: Array<{ __typename?: 'GRAReleaseLevelItemDefinition', parentId?: string | null, levelId?: string | null, shortName?: string | null, longName?: string | null, name?: string | null, weighting?: number | null, type?: string | null } | null> | null, level3?: Array<{ __typename?: 'GRAReleaseLevelItemDefinition', parentId?: string | null, levelId?: string | null, shortName?: string | null, longName?: string | null, name?: string | null, weighting?: number | null, type?: string | null } | null> | null } | null, level1: { __typename?: 'GRALevel1', level2s: Array<{ __typename?: 'GRALevel2', id: string, name: string, key: string, aggregateData: { __typename?: 'AggregateData', min: number, lowerQuartile: number, median: number, upperQuartile: number, max: number }, result: { __typename?: 'Level2Result', id: string, score: number }, results: Array<{ __typename?: 'Level2Result', id: string, score: number, scoreNumber: number, institution: { __typename?: 'Institution', id: string, institutionId: string, name: string } }> }> } } | null };

export type GetScenarioWaterfallQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  institutionId: Scalars['String']['input'];
}>;


export type GetScenarioWaterfallQuery = { __typename?: 'Query', wurRelease?: { __typename?: 'WURRelease', id: string, subject?: { __typename?: 'WURSubject', pillars: Array<{ __typename?: 'WURPillar', id: string, name: string, metrics: Array<{ __typename?: 'WURMetric', id: string, shortName: string, name: string, valueType: WurValueType, weighting: number, key: string, result?: { __typename?: 'WURMetricScore', score: number } | null }> }> } | null } | null };

export type GetWurSubjectMetricQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  selectedSubject: Scalars['String']['input'];
  myId: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWurSubjectMetricQuery = { __typename?: 'Query', wurRelease?: { __typename?: 'WURRelease', subject?: { __typename?: 'WURSubject', key: string, name: string, pillars: Array<{ __typename?: 'WURPillar', id: string, name: string, metrics: Array<{ __typename?: 'WURMetric', id: string, name: string, key: string, valueType: WurValueType, aggregateValueData?: { __typename?: 'WURAggregateData', min: number, lowerQuartile: number, median: number, upperQuartile: number, max: number } | null, aggregateScoreData?: { __typename?: 'WURAggregateData', min: number, lowerQuartile: number, median: number, upperQuartile: number, max: number } | null, result?: { __typename?: 'WURMetricScore', id: string, score: number, value?: number | null, isImputed: boolean, institution: { __typename?: 'WURInstitution', id: string, institutionId: string, name: string } } | null, results: Array<{ __typename?: 'WURMetricScore', id: string, score: number, value?: number | null, isImputed: boolean, institution: { __typename?: 'WURInstitution', id: string, institutionId: string, name: string } }> }> }> } | null, subjects: Array<{ __typename?: 'WURSubject', id: string, key: string, name: string, results: Array<{ __typename?: 'WURSubjectResult', scoreNumber?: number | null, institution: { __typename?: 'WURInstitution', id: string, institutionId: string, name: string } }> }>, institutionData?: { __typename?: 'WURInstitutionData', pppToUsd: number, institution: { __typename?: 'WURInstitution', name: string, id: string, institutionId: string } } | null, institutionsData?: { __typename?: 'WURReleaseInstitutions', data: Array<{ __typename?: 'WURInstitutionData', pppToUsd: number, institution: { __typename?: 'WURInstitution', name: string, id: string, institutionId: string } }> } | null } | null };

export type GetGraSubjectMetricQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  institutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  selectedSubject: Scalars['String']['input'];
  myId: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetGraSubjectMetricQuery = { __typename?: 'Query', newrelease?: { __typename?: 'GRARelease', level1: { __typename?: 'GRALevel1', key: string, name: string, level2s: Array<{ __typename?: 'GRALevel2', id: string, name: string, level3s: Array<{ __typename?: 'GRALevel3', id: string, name: string, key: string, valueType: ValueType, aggregateValueData: { __typename?: 'AggregateData', min: number, lowerQuartile: number, median: number, upperQuartile: number, max: number }, aggregateScoreData: { __typename?: 'AggregateData', min: number, lowerQuartile: number, median: number, upperQuartile: number, max: number }, result: { __typename?: 'Result', id: string, score: number, value: number, isImputed?: boolean | null, institution: { __typename?: 'Institution', id: string, institutionId: string, name: string } }, results: Array<{ __typename?: 'Result', id: string, score: number, value: number, isImputed?: boolean | null, institution: { __typename?: 'Institution', id: string, institutionId: string, name: string } }> }> }> }, level1s: Array<{ __typename?: 'GRALevel1', id: string, key: string, name: string, results: Array<{ __typename?: 'Level1Result', scoreNumber: number, institution: { __typename?: 'Institution', id: string, institutionId: string, name: string } }> }>, institutionData?: { __typename?: 'GRAInstitutionData', pppToUsd: number, institution: { __typename?: 'Institution', name: string, id: string, institutionId: string } } | null, institutionsData?: { __typename?: 'InstitutionsData', data: Array<{ __typename?: 'GRAInstitutionData', pppToUsd: number, institution: { __typename?: 'Institution', name: string, id: string, institutionId: string } }> } | null } | null };

export type GetWurRatingScoreAndLevelDefinitionsQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  institutionId: Scalars['String']['input'];
}>;


export type GetWurRatingScoreAndLevelDefinitionsQuery = { __typename?: 'Query', wurRelease?: { __typename?: 'WURRelease', levelDefinitions?: { __typename?: 'WURReleaseLevelDefinitions', level2?: Array<{ __typename?: 'WURReleaseLevelItemDefinition', parentId?: string | null, levelId?: string | null, shortName?: string | null, longName?: string | null, name?: string | null, weighting?: number | null, type?: string | null, rankingYear?: number | null } | null> | null, level3?: Array<{ __typename?: 'WURReleaseLevelItemDefinition', parentId?: string | null, levelId?: string | null, shortName?: string | null, longName?: string | null, name?: string | null, weighting?: number | null, type?: string | null, rankingYear?: number | null } | null> | null } | null, subject?: { __typename?: 'WURSubject', result?: { __typename?: 'WURSubjectResult', score: { __typename?: 'WURBanding', higher: number, lower: number }, rank: { __typename?: 'WURBanding', higher: number, lower: number } } | null } | null } | null };

export type ScenarioQueryVariables = Exact<{
  scenarioId: Scalars['String']['input'];
  institutionId: Scalars['String']['input'];
  allowScoresForExcluded: Scalars['Boolean']['input'];
}>;


export type ScenarioQuery = { __typename?: 'Query', scenario?: { __typename?: 'Scenario', scenarioId: string, name: string, methodology: string, createdAt: any, updatedAt: any, submissionYear?: number | null, publicationYear?: number | null, institution: { __typename?: 'ExploreInstitution', id: string, country: string, currencyCode?: string | null }, scenarioInputs: { __typename?: 'ScenarioData', overall?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null, artsAndHumanities?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null, businessAndEconomics?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null, clinicalAndHealth?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null, computerScience?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null, education?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null, engineering?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null, law?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null, lifeSciences?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null, physicalSciences?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null, psychology?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null, socialSciences?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null }, alexanderJson: { __typename?: 'ScenarioResult', overall?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null, artsAndHumanities?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null, businessAndEconomics?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null, clinicalAndHealth?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null, computerScience?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null, education?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null, engineering?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null, law?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null, lifeSciences?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null, physicalSciences?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null, psychology?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null, socialSciences?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null } } | null };

export type WurReporterInterimScenarioQueryVariables = Exact<{
  scenarioId: Scalars['String']['input'];
  institutionId: Scalars['String']['input'];
  allowScoresForExcluded: Scalars['Boolean']['input'];
}>;


export type WurReporterInterimScenarioQuery = { __typename?: 'Query', wurReporterInterimScenario?: { __typename?: 'Scenario', scenarioId: string, name: string, methodology: string, createdAt: any, updatedAt: any, submissionYear?: number | null, publicationYear?: number | null, institution: { __typename?: 'ExploreInstitution', id: string, country: string, currencyCode?: string | null }, scenarioInputs: { __typename?: 'ScenarioData', overall?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null, artsAndHumanities?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null, businessAndEconomics?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null, clinicalAndHealth?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null, computerScience?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null, education?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null, engineering?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null, law?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null, lifeSciences?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null, physicalSciences?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null, psychology?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null, socialSciences?: { __typename?: 'SubjectsFields', applicable?: boolean | null } | null }, alexanderJson: { __typename?: 'ScenarioResult', overall?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null, artsAndHumanities?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null, businessAndEconomics?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null, clinicalAndHealth?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null, computerScience?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null, education?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null, engineering?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null, law?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null, lifeSciences?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null, physicalSciences?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null, psychology?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null, socialSciences?: { __typename?: 'ScenarioResultFields', applicable: boolean, scoreNumber?: string | null, scoreDisplay?: string | null, rankNumber?: string | null, rankDisplay?: string | null, exclusions?: Array<string | null> | null } | null } } | null };

export type AcceptImpactEmbargoMutationVariables = Exact<{
  institutionId: Scalars['String']['input'];
  year: Scalars['Int']['input'];
  dataset: Scalars['String']['input'];
  productName: Scalars['String']['input'];
}>;


export type AcceptImpactEmbargoMutation = { __typename?: 'Mutation', acceptEmbargo: Array<{ __typename?: 'ResourcePermission', resource: string, actions: Array<{ __typename?: 'PermissionAction', action: string, grant: boolean }> }> };

export type GetImpactRankingsByYearsQueryVariables = Exact<{
  years?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  institutionId?: InputMaybe<Scalars['String']['input']>;
  level1Id?: InputMaybe<Scalars['String']['input']>;
  releaseNames: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  responseFields?: InputMaybe<Array<InputMaybe<ResponseFields2ListItem>> | InputMaybe<ResponseFields2ListItem>>;
}>;


export type GetImpactRankingsByYearsQuery = { __typename?: 'Query', releases: Array<{ __typename?: 'GRARelease', id: string, year: number, level1: { __typename?: 'GRALevel1', id: string, result?: { __typename?: 'Level1Result', jointRanked: boolean, rank: { __typename?: 'GRABanding', lower: number, higher: number } } | null } }> };
